const api = {
  "openapi": "3.0.3",
  "components": {
    "schemas": {
      "active_storage_attachment": {
        "x-rhino-model": {
          "model": "active_storage_attachment",
          "modelPlural": "active_storage/attachments",
          "name": "activeStorage::Attachment",
          "pluralName": "activeStorage::Attachments",
          "readableName": "Attachment",
          "pluralReadableName": "Attachments",
          "ownedBy": null,
          "singular": false,
          "path": "/api/attachments",
          "searchable": false
        },
        "type": "object",
        "properties": {
          "id": {
            "x-rhino-attribute": {
              "name": "id",
              "readableName": "Id",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "identifier"
          },
          "name": {
            "x-rhino-attribute": {
              "name": "name",
              "readableName": "Name",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "type": "string"
          },
          "record_type": {
            "x-rhino-attribute": {
              "name": "record_type",
              "readableName": "Record Type",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "type": "string"
          },
          "created_at": {
            "x-rhino-attribute": {
              "name": "created_at",
              "readableName": "Created At",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "string",
            "format": "datetime"
          },
          "url": {
            "x-rhino-attribute": {
              "name": "url",
              "readableName": "Url",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true
          },
          "url_attachment": {
            "x-rhino-attribute": {
              "name": "url_attachment",
              "readableName": "Url Attachment",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true
          },
          "previews": {
            "x-rhino-attribute": {
              "name": "previews",
              "readableName": "Previews",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "default": {
            },
            "type": "json"
          },
          "representations": {
            "x-rhino-attribute": {
              "name": "representations",
              "readableName": "Representations",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "default": {
            },
            "type": "json"
          },
          "variants": {
            "x-rhino-attribute": {
              "name": "variants",
              "readableName": "Variants",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "default": {
            },
            "type": "json"
          },
          "signed_id": {
            "x-rhino-attribute": {
              "name": "signed_id",
              "readableName": "Signed",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": true,
            "type": "unknown"
          }
        },
        "required": [
          "name",
          "record_type"
        ]
      },
      "user": {
        "x-rhino-model": {
          "model": "user",
          "modelPlural": "users",
          "name": "user",
          "pluralName": "users",
          "readableName": "User",
          "pluralReadableName": "Users",
          "ownedBy": "default_organization",
          "singular": false,
          "path": "/api/users",
          "searchable": false
        },
        "type": "object",
        "properties": {
          "id": {
            "x-rhino-attribute": {
              "name": "id",
              "readableName": "Id",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "identifier"
          },
          "name": {
            "x-rhino-attribute": {
              "name": "name",
              "readableName": "Name",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": true,
            "type": "string"
          },
          "nickname": {
            "x-rhino-attribute": {
              "name": "nickname",
              "readableName": "Nickname",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": true,
            "type": "string"
          },
          "email": {
            "x-rhino-attribute": {
              "name": "email",
              "readableName": "Email",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "string",
            "pattern": "^[^@\\s]+@[^@\\s]+$"
          },
          "image": {
            "x-rhino-attribute": {
              "name": "image",
              "readableName": "Image",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": true,
            "type": "string"
          },
          "first_name": {
            "x-rhino-attribute": {
              "name": "first_name",
              "readableName": "First Name",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "string"
          },
          "last_name": {
            "x-rhino-attribute": {
              "name": "last_name",
              "readableName": "Last Name",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "string"
          },
          "sign_in_count": {
            "x-rhino-attribute": {
              "name": "sign_in_count",
              "readableName": "Sign In Count",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "default": 0,
            "type": "integer"
          },
          "profile_completed": {
            "x-rhino-attribute": {
              "name": "profile_completed",
              "readableName": "Profile Completed",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "default": false,
            "type": "boolean"
          },
          "feedback_submitted": {
            "x-rhino-attribute": {
              "name": "feedback_submitted",
              "readableName": "Feedback Submitted",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "default": false,
            "type": "boolean"
          },
          "code_gen_model": {
            "x-rhino-attribute": {
              "name": "code_gen_model",
              "readableName": "Code Gen Model",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "string"
          },
          "industry": {
            "x-rhino-attribute": {
              "name": "industry",
              "readableName": "Industry",
              "readable": false,
              "creatable": true,
              "updatable": true
            },
            "writeOnly": true,
            "nullable": true,
            "type": "string"
          },
          "job_title": {
            "x-rhino-attribute": {
              "name": "job_title",
              "readableName": "Job Title",
              "readable": false,
              "creatable": true,
              "updatable": true
            },
            "writeOnly": true,
            "nullable": true,
            "type": "string"
          },
          "referral_source": {
            "x-rhino-attribute": {
              "name": "referral_source",
              "readableName": "Referral Source",
              "readable": false,
              "creatable": true,
              "updatable": true
            },
            "writeOnly": true,
            "nullable": true,
            "type": "string"
          },
          "default_organization_id": {
            "x-rhino-attribute": {
              "name": "default_organization_id",
              "readableName": "Default Organization",
              "readable": false,
              "creatable": true,
              "updatable": true
            },
            "writeOnly": true,
            "nullable": true,
            "type": "integer"
          }
        }
      },
      "account": {
        "x-rhino-model": {
          "model": "account",
          "modelPlural": "accounts",
          "name": "account",
          "pluralName": "accounts",
          "readableName": "Account",
          "pluralReadableName": "Accounts",
          "ownedBy": "global",
          "singular": true,
          "path": "/api/account",
          "searchable": false
        },
        "type": "object",
        "properties": {
          "id": {
            "x-rhino-attribute": {
              "name": "id",
              "readableName": "Id",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "identifier"
          },
          "name": {
            "x-rhino-attribute": {
              "name": "name",
              "readableName": "Name",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": true,
            "type": "string"
          },
          "nickname": {
            "x-rhino-attribute": {
              "name": "nickname",
              "readableName": "Nickname",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": true,
            "type": "string"
          },
          "email": {
            "x-rhino-attribute": {
              "name": "email",
              "readableName": "Email",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "string",
            "pattern": "^[^@\\s]+@[^@\\s]+$"
          },
          "image": {
            "x-rhino-attribute": {
              "name": "image",
              "readableName": "Image",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": true,
            "type": "string"
          },
          "users_roles": {
            "x-rhino-attribute": {
              "name": "users_roles",
              "readableName": "Users Roles",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": true,
            "type": "array",
            "items": {
              "type": "reference",
              "anyOf": [
                {
                  "$ref": "#/components/schemas/users_role"
                }
              ],
              "x-rhino-attribute-array": {
              }
            }
          },
          "app_credentials": {
            "x-rhino-attribute": {
              "name": "app_credentials",
              "readableName": "App Credentials",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": true,
            "type": "array",
            "items": {
              "type": "reference",
              "anyOf": [
                {
                  "$ref": "#/components/schemas/app_credential"
                }
              ],
              "x-rhino-attribute-array": {
              }
            }
          },
          "default_organization_id": {
            "x-rhino-attribute": {
              "name": "default_organization_id",
              "readableName": "Default Organization",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "integer"
          }
        }
      },
      "organization": {
        "x-rhino-model": {
          "model": "organization",
          "modelPlural": "organizations",
          "name": "organization",
          "pluralName": "organizations",
          "readableName": "Organization",
          "pluralReadableName": "Organizations",
          "ownedBy": null,
          "singular": false,
          "path": "/api/organizations",
          "searchable": false
        },
        "type": "object",
        "properties": {
          "id": {
            "x-rhino-attribute": {
              "name": "id",
              "readableName": "Id",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "identifier"
          },
          "name": {
            "x-rhino-attribute": {
              "name": "name",
              "readableName": "Name",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "string"
          },
          "created_at": {
            "x-rhino-attribute": {
              "name": "created_at",
              "readableName": "Created At",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "string",
            "format": "datetime"
          },
          "updated_at": {
            "x-rhino-attribute": {
              "name": "updated_at",
              "readableName": "Updated At",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "string",
            "format": "datetime"
          },
          "monthly_credits_balance": {
            "x-rhino-attribute": {
              "name": "monthly_credits_balance",
              "readableName": "Monthly Credits Balance",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "default": 0,
            "type": "integer"
          },
          "bonus_credits_balance": {
            "x-rhino-attribute": {
              "name": "bonus_credits_balance",
              "readableName": "Bonus Credits Balance",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "default": 0,
            "type": "integer"
          },
          "last_daily_bonus_at": {
            "x-rhino-attribute": {
              "name": "last_daily_bonus_at",
              "readableName": "Last Daily Bonus At",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": true,
            "type": "string",
            "format": "datetime"
          },
          "trial_ends_at": {
            "x-rhino-attribute": {
              "name": "trial_ends_at",
              "readableName": "Trial Ends At",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": true,
            "type": "string",
            "format": "datetime"
          },
          "topup_credits_balance": {
            "x-rhino-attribute": {
              "name": "topup_credits_balance",
              "readableName": "Topup Credits Balance",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "default": 0,
            "type": "integer"
          },
          "enable_code_gen_tech_questions": {
            "x-rhino-attribute": {
              "name": "enable_code_gen_tech_questions",
              "readableName": "Enable Code Gen Tech Questions",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "default": false,
            "type": "boolean"
          },
          "users_roles": {
            "x-rhino-attribute": {
              "name": "users_roles",
              "readableName": "Users Roles",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": true,
            "type": "array",
            "items": {
              "type": "reference",
              "anyOf": [
                {
                  "$ref": "#/components/schemas/users_role"
                }
              ],
              "x-rhino-attribute-array": {
              }
            }
          }
        }
      },
      "users_role": {
        "x-rhino-model": {
          "model": "users_role",
          "modelPlural": "users_roles",
          "name": "usersRole",
          "pluralName": "usersRoles",
          "readableName": "Users role",
          "pluralReadableName": "Users roles",
          "ownedBy": "organization",
          "singular": false,
          "path": "/api/users_roles",
          "searchable": false
        },
        "type": "object",
        "properties": {
          "id": {
            "x-rhino-attribute": {
              "name": "id",
              "readableName": "Id",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "identifier"
          },
          "created_at": {
            "x-rhino-attribute": {
              "name": "created_at",
              "readableName": "Created At",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "string",
            "format": "datetime"
          },
          "updated_at": {
            "x-rhino-attribute": {
              "name": "updated_at",
              "readableName": "Updated At",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "string",
            "format": "datetime"
          },
          "user": {
            "x-rhino-attribute": {
              "name": "user",
              "readableName": "User",
              "readable": true,
              "creatable": true,
              "updatable": false
            },
            "nullable": false,
            "type": "reference",
            "anyOf": [
              {
                "$ref": "#/components/schemas/user"
              }
            ]
          },
          "role": {
            "x-rhino-attribute": {
              "name": "role",
              "readableName": "Role",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "type": "reference",
            "anyOf": [
              {
                "$ref": "#/components/schemas/role"
              }
            ]
          },
          "organization": {
            "x-rhino-attribute": {
              "name": "organization",
              "readableName": "Organization",
              "readable": true,
              "creatable": true,
              "updatable": false
            },
            "nullable": false,
            "type": "reference",
            "anyOf": [
              {
                "$ref": "#/components/schemas/organization"
              }
            ]
          }
        },
        "required": [
          "user",
          "role",
          "organization"
        ]
      },
      "role": {
        "x-rhino-model": {
          "model": "role",
          "modelPlural": "roles",
          "name": "role",
          "pluralName": "roles",
          "readableName": "Role",
          "pluralReadableName": "Roles",
          "ownedBy": "global",
          "singular": false,
          "path": "/api/roles",
          "searchable": false
        },
        "type": "object",
        "properties": {
          "id": {
            "x-rhino-attribute": {
              "name": "id",
              "readableName": "Id",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "identifier"
          },
          "name": {
            "x-rhino-attribute": {
              "name": "name",
              "readableName": "Name",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "type": "string",
            "pattern": "^[a-zA-Z_]+$"
          },
          "created_at": {
            "x-rhino-attribute": {
              "name": "created_at",
              "readableName": "Created At",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "string",
            "format": "datetime"
          },
          "updated_at": {
            "x-rhino-attribute": {
              "name": "updated_at",
              "readableName": "Updated At",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "string",
            "format": "datetime"
          }
        },
        "required": [
          "name"
        ]
      },
      "users_role_invite": {
        "x-rhino-model": {
          "model": "users_role_invite",
          "modelPlural": "users_role_invites",
          "name": "usersRoleInvite",
          "pluralName": "usersRoleInvites",
          "readableName": "Users role invite",
          "pluralReadableName": "Users role invites",
          "ownedBy": "organization",
          "singular": false,
          "path": "/api/users_role_invites",
          "searchable": false
        },
        "type": "object",
        "properties": {
          "id": {
            "x-rhino-attribute": {
              "name": "id",
              "readableName": "Id",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "identifier"
          },
          "email": {
            "x-rhino-attribute": {
              "name": "email",
              "readableName": "Email",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "type": "string"
          },
          "created_at": {
            "x-rhino-attribute": {
              "name": "created_at",
              "readableName": "Created At",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "string",
            "format": "datetime"
          },
          "updated_at": {
            "x-rhino-attribute": {
              "name": "updated_at",
              "readableName": "Updated At",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "string",
            "format": "datetime"
          },
          "role": {
            "x-rhino-attribute": {
              "name": "role",
              "readableName": "Role",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "type": "reference",
            "anyOf": [
              {
                "$ref": "#/components/schemas/role"
              }
            ]
          },
          "organization": {
            "x-rhino-attribute": {
              "name": "organization",
              "readableName": "Organization",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "type": "reference",
            "anyOf": [
              {
                "$ref": "#/components/schemas/organization"
              }
            ]
          }
        },
        "required": [
          "email",
          "role",
          "organization"
        ]
      },
      "live_dev": {
        "x-rhino-model": {
          "model": "live_dev",
          "modelPlural": "live_devs",
          "name": "liveDev",
          "pluralName": "liveDevs",
          "readableName": "Live dev",
          "pluralReadableName": "Live devs",
          "ownedBy": "repository",
          "singular": false,
          "path": "/api/live_devs",
          "searchable": false
        },
        "type": "object",
        "properties": {
          "id": {
            "x-rhino-attribute": {
              "name": "id",
              "readableName": "Id",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "identifier"
          },
          "uuid": {
            "x-rhino-attribute": {
              "name": "uuid",
              "readableName": "Uuid",
              "readable": true,
              "creatable": true,
              "updatable": false
            },
            "nullable": false,
            "type": "string"
          },
          "created_at": {
            "x-rhino-attribute": {
              "name": "created_at",
              "readableName": "Created At",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "string",
            "format": "datetime"
          },
          "updated_at": {
            "x-rhino-attribute": {
              "name": "updated_at",
              "readableName": "Updated At",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "string",
            "format": "datetime"
          },
          "pinged_at": {
            "x-rhino-attribute": {
              "name": "pinged_at",
              "readableName": "Pinged At",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "string",
            "format": "datetime"
          },
          "front_end_url": {
            "x-rhino-attribute": {
              "name": "front_end_url",
              "readableName": "Front End Url",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "string"
          },
          "back_end_url": {
            "x-rhino-attribute": {
              "name": "back_end_url",
              "readableName": "Back End Url",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "string"
          },
          "health_check_url": {
            "x-rhino-attribute": {
              "name": "health_check_url",
              "readableName": "Health Check Url",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "string"
          },
          "agent_url": {
            "x-rhino-attribute": {
              "name": "agent_url",
              "readableName": "Agent Url",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "string"
          },
          "vscode_url": {
            "x-rhino-attribute": {
              "name": "vscode_url",
              "readableName": "Vscode Url",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "string"
          },
          "repository": {
            "x-rhino-attribute": {
              "name": "repository",
              "readableName": "Repository",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "type": "reference",
            "anyOf": [
              {
                "$ref": "#/components/schemas/repository"
              }
            ]
          }
        },
        "required": [
          "uuid",
          "repository"
        ]
      },
      "planning": {
        "x-rhino-model": {
          "model": "planning",
          "modelPlural": "plannings",
          "name": "planning",
          "pluralName": "plannings",
          "readableName": "Planning",
          "pluralReadableName": "Plannings",
          "ownedBy": "product",
          "singular": false,
          "path": "/api/plannings",
          "searchable": false
        },
        "type": "object",
        "properties": {
          "id": {
            "x-rhino-attribute": {
              "name": "id",
              "readableName": "Id",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "identifier"
          },
          "user_personas": {
            "x-rhino-attribute": {
              "name": "user_personas",
              "readableName": "User Personas",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "jsonb"
          },
          "user_stories": {
            "x-rhino-attribute": {
              "name": "user_stories",
              "readableName": "User Stories",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "jsonb"
          },
          "created_at": {
            "x-rhino-attribute": {
              "name": "created_at",
              "readableName": "Created At",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "string",
            "format": "datetime"
          },
          "updated_at": {
            "x-rhino-attribute": {
              "name": "updated_at",
              "readableName": "Updated At",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "string",
            "format": "datetime"
          },
          "stage": {
            "x-rhino-attribute": {
              "name": "stage",
              "readableName": "Stage",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "default": "user_personas",
            "type": "string",
            "enum": [
              "initial",
              "user_personas",
              "user_stories",
              "rhino_modules",
              "data_model",
              "complete"
            ]
          },
          "stage_status": {
            "x-rhino-attribute": {
              "name": "stage_status",
              "readableName": "Stage Status",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "default": "idle",
            "type": "string",
            "enum": [
              "idle",
              "generating",
              "regenerating",
              "error"
            ]
          },
          "build_stage": {
            "x-rhino-attribute": {
              "name": "build_stage",
              "readableName": "Build Stage",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": "idle",
            "type": "string",
            "enum": [
              "idle",
              "processing_prd",
              "creating_repository",
              "setting_up_data_models",
              "completed"
            ]
          },
          "build_status": {
            "x-rhino-attribute": {
              "name": "build_status",
              "readableName": "Build Status",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": "idle",
            "type": "string",
            "enum": [
              "idle",
              "processing",
              "error",
              "completed"
            ]
          },
          "build_failure": {
            "x-rhino-attribute": {
              "name": "build_failure",
              "readableName": "Build Failure",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": {
            },
            "type": "jsonb"
          },
          "build_stages_completed": {
            "x-rhino-attribute": {
              "name": "build_stages_completed",
              "readableName": "Build Stages Completed",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": [

            ],
            "type": "jsonb"
          },
          "product": {
            "x-rhino-attribute": {
              "name": "product",
              "readableName": "Product",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "reference",
            "anyOf": [
              {
                "$ref": "#/components/schemas/product"
              }
            ]
          },
          "prd": {
            "x-rhino-attribute": {
              "name": "prd",
              "readableName": "Prd",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "type": "reference",
            "anyOf": [
              {
                "$ref": "#/components/schemas/prd"
              }
            ]
          },
          "ai_model": {
            "x-rhino-attribute": {
              "name": "ai_model",
              "readableName": "Ai Model",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "type": "reference",
            "anyOf": [
              {
                "$ref": "#/components/schemas/ai_model"
              }
            ]
          },
          "rhino_modules": {
            "x-rhino-attribute": {
              "name": "rhino_modules",
              "readableName": "Rhino Modules",
              "readable": false,
              "creatable": true,
              "updatable": true
            },
            "writeOnly": true,
            "nullable": true,
            "type": "jsonb"
          },
          "data_model": {
            "x-rhino-attribute": {
              "name": "data_model",
              "readableName": "Data Model",
              "readable": false,
              "creatable": true,
              "updatable": true
            },
            "writeOnly": true,
            "nullable": true,
            "type": "jsonb"
          },
          "discarded_at": {
            "x-rhino-attribute": {
              "name": "discarded_at",
              "readableName": "Discarded At",
              "readable": false,
              "creatable": false,
              "updatable": true
            },
            "writeOnly": true,
            "nullable": true,
            "type": "string",
            "format": "datetime"
          }
        },
        "required": [
          "build_stage",
          "build_status",
          "build_failure",
          "build_stages_completed",
          "prd",
          "ai_model"
        ]
      },
      "plugin": {
        "x-rhino-model": {
          "model": "plugin",
          "modelPlural": "plugins",
          "name": "plugin",
          "pluralName": "plugins",
          "readableName": "Plugin",
          "pluralReadableName": "Plugins",
          "ownedBy": "global",
          "singular": false,
          "path": "/api/plugins",
          "searchable": false
        },
        "type": "object",
        "properties": {
          "id": {
            "x-rhino-attribute": {
              "name": "id",
              "readableName": "Id",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "identifier"
          },
          "name": {
            "x-rhino-attribute": {
              "name": "name",
              "readableName": "Name",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "type": "string"
          },
          "created_at": {
            "x-rhino-attribute": {
              "name": "created_at",
              "readableName": "Created At",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "string",
            "format": "datetime"
          },
          "updated_at": {
            "x-rhino-attribute": {
              "name": "updated_at",
              "readableName": "Updated At",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "string",
            "format": "datetime"
          },
          "slug": {
            "x-rhino-attribute": {
              "name": "slug",
              "readableName": "Slug",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "type": "string"
          },
          "description": {
            "x-rhino-attribute": {
              "name": "description",
              "readableName": "Description",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "text"
          },
          "virtual": {
            "x-rhino-attribute": {
              "name": "virtual",
              "readableName": "Virtual",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "default": false,
            "type": "boolean"
          },
          "icon": {
            "x-rhino-attribute": {
              "name": "icon",
              "readableName": "Icon",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "string"
          }
        },
        "required": [
          "name",
          "slug"
        ]
      },
      "product": {
        "x-rhino-model": {
          "model": "product",
          "modelPlural": "products",
          "name": "product",
          "pluralName": "products",
          "readableName": "Product",
          "pluralReadableName": "Products",
          "ownedBy": "organization",
          "singular": false,
          "path": "/api/products",
          "searchable": true
        },
        "type": "object",
        "properties": {
          "id": {
            "x-rhino-attribute": {
              "name": "id",
              "readableName": "Id",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "identifier"
          },
          "name": {
            "x-rhino-attribute": {
              "name": "name",
              "readableName": "Name",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "type": "string",
            "minLength": 3
          },
          "slug": {
            "x-rhino-attribute": {
              "name": "slug",
              "readableName": "Slug",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": true,
            "type": "string"
          },
          "ai_status": {
            "x-rhino-attribute": {
              "name": "ai_status",
              "readableName": "Ai Status",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": "idle",
            "type": "string",
            "enum": [
              "idle",
              "busy",
              "error"
            ]
          },
          "created_at": {
            "x-rhino-attribute": {
              "name": "created_at",
              "readableName": "Created At",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "string",
            "format": "datetime"
          },
          "updated_at": {
            "x-rhino-attribute": {
              "name": "updated_at",
              "readableName": "Updated At",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "string",
            "format": "datetime"
          },
          "project": {
            "x-rhino-attribute": {
              "name": "project",
              "readableName": "Project",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "text"
          },
          "score": {
            "x-rhino-attribute": {
              "name": "score",
              "readableName": "Score",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": true,
            "type": "integer",
            "minimum": 1,
            "maximum": 10
          },
          "budget": {
            "x-rhino-attribute": {
              "name": "budget",
              "readableName": "Budget",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": "unknown",
            "type": "string",
            "enum": [
              "unknown",
              "ten_thousand",
              "twenty_thousand",
              "fifty_thousand",
              "onehundred_thousand",
              "none"
            ]
          },
          "revenue_model": {
            "x-rhino-attribute": {
              "name": "revenue_model",
              "readableName": "Revenue Model",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": "unknown",
            "type": "string",
            "enum": [
              "unknown",
              "subscription",
              "transaction",
              "usage",
              "advertising",
              "onetime",
              "license",
              "other",
              "none"
            ]
          },
          "market_orientation": {
            "x-rhino-attribute": {
              "name": "market_orientation",
              "readableName": "Market Orientation",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": "unknown",
            "type": "string",
            "enum": [
              "unknown",
              "b2b",
              "b2c",
              "b2b2c",
              "c2c",
              "b2g",
              "other",
              "none"
            ]
          },
          "personal": {
            "x-rhino-attribute": {
              "name": "personal",
              "readableName": "Personal",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": false,
            "type": "boolean"
          },
          "elevator": {
            "x-rhino-attribute": {
              "name": "elevator",
              "readableName": "Elevator",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "text"
          },
          "speaker": {
            "x-rhino-attribute": {
              "name": "speaker",
              "readableName": "Speaker",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "default": "agent_project_manager",
            "type": "string"
          },
          "agent_project_manager": {
            "x-rhino-attribute": {
              "name": "agent_project_manager",
              "readableName": "Agent Project Manager",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "jsonb"
          },
          "agent_designer": {
            "x-rhino-attribute": {
              "name": "agent_designer",
              "readableName": "Agent Designer",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "jsonb"
          },
          "agent_architect": {
            "x-rhino-attribute": {
              "name": "agent_architect",
              "readableName": "Agent Architect",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "jsonb"
          },
          "agent_product_manager": {
            "x-rhino-attribute": {
              "name": "agent_product_manager",
              "readableName": "Agent Product Manager",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "jsonb"
          },
          "ai_error": {
            "x-rhino-attribute": {
              "name": "ai_error",
              "readableName": "Ai Error",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "text"
          },
          "is_agent": {
            "x-rhino-attribute": {
              "name": "is_agent",
              "readableName": "Is Agent",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "boolean"
          },
          "running_agent_slugs": {
            "x-rhino-attribute": {
              "name": "running_agent_slugs",
              "readableName": "Running Agent Slugs",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "jsonb"
          },
          "description": {
            "x-rhino-attribute": {
              "name": "description",
              "readableName": "Description",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "text"
          },
          "rhino_data_model": {
            "x-rhino-attribute": {
              "name": "rhino_data_model",
              "readableName": "Rhino Data Model",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "jsonb"
          },
          "dev_planning": {
            "x-rhino-attribute": {
              "name": "dev_planning",
              "readableName": "Dev Planning",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": {
            },
            "type": "jsonb"
          },
          "market_sizing_doc": {
            "x-rhino-attribute": {
              "name": "market_sizing_doc",
              "readableName": "Market Sizing Doc",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": {
            },
            "type": "jsonb"
          },
          "estimation_completed": {
            "x-rhino-attribute": {
              "name": "estimation_completed",
              "readableName": "Estimation Completed",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": false,
            "type": "boolean"
          },
          "done_market_sizing": {
            "x-rhino-attribute": {
              "name": "done_market_sizing",
              "readableName": "Done Market Sizing",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": false,
            "type": "boolean"
          },
          "last_message_sequence": {
            "x-rhino-attribute": {
              "name": "last_message_sequence",
              "readableName": "Last Message Sequence",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": 0,
            "type": "integer",
            "minimum": 0
          },
          "prd_edit_attempts_count": {
            "x-rhino-attribute": {
              "name": "prd_edit_attempts_count",
              "readableName": "Prd Edit Attempts Count",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": 0,
            "type": "integer"
          },
          "orchestrator_workspace_removed_at": {
            "x-rhino-attribute": {
              "name": "orchestrator_workspace_removed_at",
              "readableName": "Orchestrator Workspace Removed At",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "string",
            "format": "datetime"
          },
          "orchestrator_workspace_removal_reason": {
            "x-rhino-attribute": {
              "name": "orchestrator_workspace_removal_reason",
              "readableName": "Orchestrator Workspace Removal Reason",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "string"
          },
          "orchestrator_workspace_cleanup_scheduled_at": {
            "x-rhino-attribute": {
              "name": "orchestrator_workspace_cleanup_scheduled_at",
              "readableName": "Orchestrator Workspace Cleanup Scheduled At",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "string",
            "format": "datetime"
          },
          "code_synced_commit_sha": {
            "x-rhino-attribute": {
              "name": "code_synced_commit_sha",
              "readableName": "Code Synced Commit Sha",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": true,
            "type": "string"
          },
          "code_drift_verdict": {
            "x-rhino-attribute": {
              "name": "code_drift_verdict",
              "readableName": "Code Drift Verdict",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": {
            },
            "type": "jsonb"
          },
          "code_drift_verdict_sha": {
            "x-rhino-attribute": {
              "name": "code_drift_verdict_sha",
              "readableName": "Code Drift Verdict Sha",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "string"
          },
          "code_synced_prd_fingerprint": {
            "x-rhino-attribute": {
              "name": "code_synced_prd_fingerprint",
              "readableName": "Code Synced Prd Fingerprint",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "string"
          },
          "onboarding_source": {
            "x-rhino-attribute": {
              "name": "onboarding_source",
              "readableName": "Onboarding Source",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": true,
            "type": "string",
            "enum": [
              "start",
              "studio"
            ]
          },
          "onboarding_vision": {
            "x-rhino-attribute": {
              "name": "onboarding_vision",
              "readableName": "Onboarding Vision",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": true,
            "type": "jsonb"
          },
          "onboarded_at": {
            "x-rhino-attribute": {
              "name": "onboarded_at",
              "readableName": "Onboarded At",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": true,
            "type": "string",
            "format": "datetime"
          },
          "code_generation_backend_stack": {
            "x-rhino-attribute": {
              "name": "code_generation_backend_stack",
              "readableName": "Code Generation Backend Stack",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "default": "rhino-rails",
            "type": "string",
            "enum": [
              "rhino-rails",
              "rhino-laravel",
              "rhino-nestjs"
            ]
          },
          "code_generation_stack_locked_at": {
            "x-rhino-attribute": {
              "name": "code_generation_stack_locked_at",
              "readableName": "Code Generation Stack Locked At",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": true,
            "type": "string",
            "format": "datetime"
          },
          "code_generation_workspace_preparing_at": {
            "x-rhino-attribute": {
              "name": "code_generation_workspace_preparing_at",
              "readableName": "Code Generation Workspace Preparing At",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "string",
            "format": "datetime"
          },
          "draft_claim_token": {
            "x-rhino-attribute": {
              "name": "draft_claim_token",
              "readableName": "Draft Claim Token",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "string"
          },
          "onboarding_active": {
            "x-rhino-attribute": {
              "name": "onboarding_active",
              "readableName": "Onboarding Active",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": true,
            "type": "boolean"
          },
          "onboarding_free": {
            "x-rhino-attribute": {
              "name": "onboarding_free",
              "readableName": "Onboarding Free",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": true,
            "type": "boolean"
          },
          "current_prd": {
            "x-rhino-attribute": {
              "name": "current_prd",
              "readableName": "Current Prd",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "default": [

            ],
            "type": "jsonb"
          },
          "code_gen_plan_status": {
            "x-rhino-attribute": {
              "name": "code_gen_plan_status",
              "readableName": "Code Gen Plan Status",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "default": {
            },
            "type": "jsonb"
          },
          "code_drift_status": {
            "x-rhino-attribute": {
              "name": "code_drift_status",
              "readableName": "Code Drift Status",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "default": {
            },
            "type": "jsonb"
          },
          "organization": {
            "x-rhino-attribute": {
              "name": "organization",
              "readableName": "Organization",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "type": "reference",
            "anyOf": [
              {
                "$ref": "#/components/schemas/organization"
              }
            ]
          },
          "documents_attachments": {
            "x-rhino-attribute": {
              "name": "documents_attachments",
              "readableName": "Documents Attachments",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "array",
            "items": {
              "type": "reference",
              "anyOf": [
                {
                  "$ref": "#/components/schemas/active_storage_attachment"
                }
              ],
              "x-rhino-attribute-array": {
              }
            }
          },
          "product_template": {
            "x-rhino-attribute": {
              "name": "product_template",
              "readableName": "Product Template",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "reference",
            "anyOf": [
              {
                "$ref": "#/components/schemas/product_template"
              }
            ]
          },
          "ai_history": {
            "x-rhino-attribute": {
              "name": "ai_history",
              "readableName": "Ai History",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "reference",
            "anyOf": [
              {
                "$ref": "#/components/schemas/ai_history"
              }
            ]
          },
          "ai_history_prototype": {
            "x-rhino-attribute": {
              "name": "ai_history_prototype",
              "readableName": "Ai History Prototype",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "reference",
            "anyOf": [
              {
                "$ref": "#/components/schemas/ai_history"
              }
            ]
          },
          "ai_history_editor": {
            "x-rhino-attribute": {
              "name": "ai_history_editor",
              "readableName": "Ai History Editor",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "reference",
            "anyOf": [
              {
                "$ref": "#/components/schemas/ai_history"
              }
            ]
          },
          "ai_history_code_generation": {
            "x-rhino-attribute": {
              "name": "ai_history_code_generation",
              "readableName": "Ai History Code Generation",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "reference",
            "anyOf": [
              {
                "$ref": "#/components/schemas/ai_history"
              }
            ]
          },
          "questions": {
            "x-rhino-attribute": {
              "name": "questions",
              "readableName": "Questions",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": true,
            "type": "array",
            "items": {
              "type": "reference",
              "anyOf": [
                {
                  "$ref": "#/components/schemas/question"
                }
              ],
              "x-rhino-attribute-array": {
              }
            }
          },
          "product_documents": {
            "x-rhino-attribute": {
              "name": "product_documents",
              "readableName": "Product Documents",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": true,
            "type": "array",
            "items": {
              "type": "reference",
              "anyOf": [
                {
                  "$ref": "#/components/schemas/product_document"
                }
              ],
              "x-rhino-attribute-array": {
              }
            }
          },
          "products_plugins": {
            "x-rhino-attribute": {
              "name": "products_plugins",
              "readableName": "Products Plugins",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "array",
            "items": {
              "type": "reference",
              "anyOf": [
                {
                  "$ref": "#/components/schemas/products_plugin"
                }
              ],
              "x-rhino-attribute-array": {
                "creatable": true,
                "updatable": true,
                "destroyable": true
              }
            },
            "format": "join_table_simple"
          },
          "prd_versions": {
            "x-rhino-attribute": {
              "name": "prd_versions",
              "readableName": "Prd Versions",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": true,
            "type": "array",
            "items": {
              "type": "reference",
              "anyOf": [
                {
                  "$ref": "#/components/schemas/prd"
                }
              ],
              "x-rhino-attribute-array": {
              }
            }
          },
          "active_pipeline_run": {
            "x-rhino-attribute": {
              "name": "active_pipeline_run",
              "readableName": "Active Pipeline Run",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "reference",
            "anyOf": [
              {
                "$ref": "#/components/schemas/pipeline_run"
              }
            ]
          },
          "last_pipeline_run": {
            "x-rhino-attribute": {
              "name": "last_pipeline_run",
              "readableName": "Last Pipeline Run",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "reference",
            "anyOf": [
              {
                "$ref": "#/components/schemas/pipeline_run"
              }
            ]
          },
          "queued_chat_messages": {
            "x-rhino-attribute": {
              "name": "queued_chat_messages",
              "readableName": "Queued Chat Messages",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": true,
            "type": "array",
            "items": {
              "type": "reference",
              "anyOf": [
                {
                  "$ref": "#/components/schemas/queued_chat_message"
                }
              ],
              "x-rhino-attribute-array": {
              }
            }
          },
          "live_prd_run": {
            "x-rhino-attribute": {
              "name": "live_prd_run",
              "readableName": "Live Prd Run",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "reference",
            "anyOf": [
              {
                "$ref": "#/components/schemas/agent_run"
              }
            ]
          }
        },
        "required": [
          "name",
          "ai_status",
          "budget",
          "revenue_model",
          "market_orientation",
          "personal",
          "dev_planning",
          "market_sizing_doc",
          "estimation_completed",
          "done_market_sizing",
          "last_message_sequence",
          "prd_edit_attempts_count",
          "code_drift_verdict",
          "organization"
        ]
      },
      "products_plugin": {
        "x-rhino-model": {
          "model": "products_plugin",
          "modelPlural": "products_plugins",
          "name": "productsPlugin",
          "pluralName": "productsPlugins",
          "readableName": "Products plugin",
          "pluralReadableName": "Products plugins",
          "ownedBy": "product",
          "singular": false,
          "path": "/api/products_plugins",
          "searchable": false
        },
        "type": "object",
        "properties": {
          "id": {
            "x-rhino-attribute": {
              "name": "id",
              "readableName": "Id",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "identifier"
          },
          "created_at": {
            "x-rhino-attribute": {
              "name": "created_at",
              "readableName": "Created At",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "string",
            "format": "datetime"
          },
          "updated_at": {
            "x-rhino-attribute": {
              "name": "updated_at",
              "readableName": "Updated At",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "string",
            "format": "datetime"
          },
          "product": {
            "x-rhino-attribute": {
              "name": "product",
              "readableName": "Product",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "type": "reference",
            "anyOf": [
              {
                "$ref": "#/components/schemas/product"
              }
            ]
          },
          "plugin": {
            "x-rhino-attribute": {
              "name": "plugin",
              "readableName": "Plugin",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "type": "reference",
            "anyOf": [
              {
                "$ref": "#/components/schemas/plugin"
              }
            ]
          }
        },
        "required": [
          "product",
          "plugin"
        ]
      },
      "products_variable": {
        "x-rhino-model": {
          "model": "products_variable",
          "modelPlural": "products_variables",
          "name": "productsVariable",
          "pluralName": "productsVariables",
          "readableName": "Products variable",
          "pluralReadableName": "Products variables",
          "ownedBy": "product",
          "singular": false,
          "path": "/api/products_variables",
          "searchable": false
        },
        "type": "object",
        "properties": {
          "id": {
            "x-rhino-attribute": {
              "name": "id",
              "readableName": "Id",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "identifier"
          },
          "value": {
            "x-rhino-attribute": {
              "name": "value",
              "readableName": "Value",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "string"
          },
          "created_at": {
            "x-rhino-attribute": {
              "name": "created_at",
              "readableName": "Created At",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "string",
            "format": "datetime"
          },
          "updated_at": {
            "x-rhino-attribute": {
              "name": "updated_at",
              "readableName": "Updated At",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "string",
            "format": "datetime"
          },
          "product": {
            "x-rhino-attribute": {
              "name": "product",
              "readableName": "Product",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "type": "reference",
            "anyOf": [
              {
                "$ref": "#/components/schemas/product"
              }
            ]
          },
          "variable": {
            "x-rhino-attribute": {
              "name": "variable",
              "readableName": "Variable",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "type": "reference",
            "anyOf": [
              {
                "$ref": "#/components/schemas/variable"
              }
            ]
          }
        },
        "required": [
          "product",
          "variable"
        ]
      },
      "prd": {
        "x-rhino-model": {
          "model": "prd",
          "modelPlural": "prds",
          "name": "prd",
          "pluralName": "prds",
          "readableName": "Prd",
          "pluralReadableName": "Prds",
          "ownedBy": "product",
          "singular": false,
          "path": "/api/prds",
          "searchable": false
        },
        "type": "object",
        "properties": {
          "id": {
            "x-rhino-attribute": {
              "name": "id",
              "readableName": "Id",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "identifier"
          },
          "version_number": {
            "x-rhino-attribute": {
              "name": "version_number",
              "readableName": "Version Number",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": 0,
            "type": "integer",
            "minimum": 0
          },
          "is_editable": {
            "x-rhino-attribute": {
              "name": "is_editable",
              "readableName": "Is Editable",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": false,
            "type": "boolean"
          },
          "elevator_pitch": {
            "x-rhino-attribute": {
              "name": "elevator_pitch",
              "readableName": "Elevator Pitch",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": "",
            "type": "text"
          },
          "problem_statement": {
            "x-rhino-attribute": {
              "name": "problem_statement",
              "readableName": "Problem Statement",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": "",
            "type": "text"
          },
          "solution": {
            "x-rhino-attribute": {
              "name": "solution",
              "readableName": "Solution",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": "",
            "type": "text"
          },
          "key_features": {
            "x-rhino-attribute": {
              "name": "key_features",
              "readableName": "Key Features",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": [

            ],
            "type": "jsonb"
          },
          "user_flows": {
            "x-rhino-attribute": {
              "name": "user_flows",
              "readableName": "User Flows",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": [

            ],
            "type": "jsonb"
          },
          "success_metrics": {
            "x-rhino-attribute": {
              "name": "success_metrics",
              "readableName": "Success Metrics",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": "",
            "type": "text"
          },
          "competitors": {
            "x-rhino-attribute": {
              "name": "competitors",
              "readableName": "Competitors",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": "",
            "type": "text"
          },
          "vision": {
            "x-rhino-attribute": {
              "name": "vision",
              "readableName": "Vision",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": "",
            "type": "text"
          },
          "target_audience": {
            "x-rhino-attribute": {
              "name": "target_audience",
              "readableName": "Target Audience",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": [

            ],
            "type": "jsonb"
          },
          "phasing": {
            "x-rhino-attribute": {
              "name": "phasing",
              "readableName": "Phasing",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": [

            ],
            "type": "jsonb"
          },
          "design_principles": {
            "x-rhino-attribute": {
              "name": "design_principles",
              "readableName": "Design Principles",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": "",
            "type": "text"
          },
          "user_personas": {
            "x-rhino-attribute": {
              "name": "user_personas",
              "readableName": "User Personas",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": [

            ],
            "type": "jsonb"
          },
          "user_journeys": {
            "x-rhino-attribute": {
              "name": "user_journeys",
              "readableName": "User Journeys",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": [

            ],
            "type": "jsonb"
          },
          "sitemap": {
            "x-rhino-attribute": {
              "name": "sitemap",
              "readableName": "Sitemap",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": "",
            "type": "text"
          },
          "navigation_design": {
            "x-rhino-attribute": {
              "name": "navigation_design",
              "readableName": "Navigation Design",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": "",
            "type": "text"
          },
          "description": {
            "x-rhino-attribute": {
              "name": "description",
              "readableName": "Description",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": "",
            "type": "text"
          },
          "schema": {
            "x-rhino-attribute": {
              "name": "schema",
              "readableName": "Schema",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": {
            },
            "type": "jsonb"
          },
          "sample_data": {
            "x-rhino-attribute": {
              "name": "sample_data",
              "readableName": "Sample Data",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": [

            ],
            "type": "jsonb"
          },
          "mermaid_erd_diagram": {
            "x-rhino-attribute": {
              "name": "mermaid_erd_diagram",
              "readableName": "Mermaid Erd Diagram",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": "",
            "type": "text"
          },
          "user_stories": {
            "x-rhino-attribute": {
              "name": "user_stories",
              "readableName": "User Stories",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": [

            ],
            "type": "jsonb"
          },
          "project_manager_score": {
            "x-rhino-attribute": {
              "name": "project_manager_score",
              "readableName": "Project Manager Score",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": 0,
            "type": "integer",
            "minimum": 1,
            "maximum": 10
          },
          "designer_score": {
            "x-rhino-attribute": {
              "name": "designer_score",
              "readableName": "Designer Score",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": 0,
            "type": "integer",
            "minimum": 1,
            "maximum": 10
          },
          "architect_score": {
            "x-rhino-attribute": {
              "name": "architect_score",
              "readableName": "Architect Score",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": 0,
            "type": "integer",
            "minimum": 1,
            "maximum": 10
          },
          "product_manager_score": {
            "x-rhino-attribute": {
              "name": "product_manager_score",
              "readableName": "Product Manager Score",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": 0,
            "type": "integer",
            "minimum": 1,
            "maximum": 10
          },
          "story_point_table": {
            "x-rhino-attribute": {
              "name": "story_point_table",
              "readableName": "Story Point Table",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": [

            ],
            "type": "jsonb"
          },
          "effort_by_role_summary": {
            "x-rhino-attribute": {
              "name": "effort_by_role_summary",
              "readableName": "Effort By Role Summary",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": {
            },
            "type": "jsonb"
          },
          "total_days_without_rhino": {
            "x-rhino-attribute": {
              "name": "total_days_without_rhino",
              "readableName": "Total Days Without Rhino",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": "",
            "type": "string"
          },
          "total_days_with_rhino": {
            "x-rhino-attribute": {
              "name": "total_days_with_rhino",
              "readableName": "Total Days With Rhino",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": "",
            "type": "string"
          },
          "time_estimated_without_rhino": {
            "x-rhino-attribute": {
              "name": "time_estimated_without_rhino",
              "readableName": "Time Estimated Without Rhino",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": {
            },
            "type": "jsonb"
          },
          "time_estimated_with_rhino": {
            "x-rhino-attribute": {
              "name": "time_estimated_with_rhino",
              "readableName": "Time Estimated With Rhino",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": {
            },
            "type": "jsonb"
          },
          "estimate_generated": {
            "x-rhino-attribute": {
              "name": "estimate_generated",
              "readableName": "Estimate Generated",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": false,
            "type": "boolean"
          },
          "industry_category": {
            "x-rhino-attribute": {
              "name": "industry_category",
              "readableName": "Industry Category",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": "",
            "type": "string"
          },
          "geographic_scope": {
            "x-rhino-attribute": {
              "name": "geographic_scope",
              "readableName": "Geographic Scope",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": "",
            "type": "string"
          },
          "tam_description": {
            "x-rhino-attribute": {
              "name": "tam_description",
              "readableName": "Tam Description",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": "",
            "type": "text"
          },
          "tam_estimated_value_usd": {
            "x-rhino-attribute": {
              "name": "tam_estimated_value_usd",
              "readableName": "Tam Estimated Value Usd",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": "0.0",
            "type": "decimal"
          },
          "tam_estimation_basis": {
            "x-rhino-attribute": {
              "name": "tam_estimation_basis",
              "readableName": "Tam Estimation Basis",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": "",
            "type": "text"
          },
          "tam_source": {
            "x-rhino-attribute": {
              "name": "tam_source",
              "readableName": "Tam Source",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": "",
            "type": "string"
          },
          "sam_description": {
            "x-rhino-attribute": {
              "name": "sam_description",
              "readableName": "Sam Description",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": "",
            "type": "text"
          },
          "sam_estimated_value_usd": {
            "x-rhino-attribute": {
              "name": "sam_estimated_value_usd",
              "readableName": "Sam Estimated Value Usd",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": "0.0",
            "type": "decimal"
          },
          "sam_estimation_basis": {
            "x-rhino-attribute": {
              "name": "sam_estimation_basis",
              "readableName": "Sam Estimation Basis",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": "",
            "type": "text"
          },
          "sam_source": {
            "x-rhino-attribute": {
              "name": "sam_source",
              "readableName": "Sam Source",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": "",
            "type": "string"
          },
          "som_description": {
            "x-rhino-attribute": {
              "name": "som_description",
              "readableName": "Som Description",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": "",
            "type": "text"
          },
          "som_estimated_value_usd": {
            "x-rhino-attribute": {
              "name": "som_estimated_value_usd",
              "readableName": "Som Estimated Value Usd",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": "0.0",
            "type": "decimal"
          },
          "som_estimation_basis": {
            "x-rhino-attribute": {
              "name": "som_estimation_basis",
              "readableName": "Som Estimation Basis",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": "",
            "type": "text"
          },
          "som_source": {
            "x-rhino-attribute": {
              "name": "som_source",
              "readableName": "Som Source",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": "",
            "type": "string"
          },
          "avg_revenue_per_user_per_year": {
            "x-rhino-attribute": {
              "name": "avg_revenue_per_user_per_year",
              "readableName": "Avg Revenue Per User Per Year",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": "0.0",
            "type": "decimal"
          },
          "expected_market_penetration_percent": {
            "x-rhino-attribute": {
              "name": "expected_market_penetration_percent",
              "readableName": "Expected Market Penetration Percent",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": "0.0",
            "type": "decimal"
          },
          "time_horizon_years": {
            "x-rhino-attribute": {
              "name": "time_horizon_years",
              "readableName": "Time Horizon Years",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": 0,
            "type": "integer"
          },
          "customer_type": {
            "x-rhino-attribute": {
              "name": "customer_type",
              "readableName": "Customer Type",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": "",
            "type": "string"
          },
          "pricing_model_basis": {
            "x-rhino-attribute": {
              "name": "pricing_model_basis",
              "readableName": "Pricing Model Basis",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": "",
            "type": "string"
          },
          "key_competitors": {
            "x-rhino-attribute": {
              "name": "key_competitors",
              "readableName": "Key Competitors",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": [

            ],
            "type": "jsonb"
          },
          "industry_growth_rate_cagr_percent": {
            "x-rhino-attribute": {
              "name": "industry_growth_rate_cagr_percent",
              "readableName": "Industry Growth Rate Cagr Percent",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": "0.0",
            "type": "decimal"
          },
          "advantage_summary": {
            "x-rhino-attribute": {
              "name": "advantage_summary",
              "readableName": "Advantage Summary",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": "",
            "type": "text"
          },
          "market_sizing_generated": {
            "x-rhino-attribute": {
              "name": "market_sizing_generated",
              "readableName": "Market Sizing Generated",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": false,
            "type": "boolean"
          },
          "created_at": {
            "x-rhino-attribute": {
              "name": "created_at",
              "readableName": "Created At",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "string",
            "format": "datetime"
          },
          "updated_at": {
            "x-rhino-attribute": {
              "name": "updated_at",
              "readableName": "Updated At",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "string",
            "format": "datetime"
          },
          "edit_mode": {
            "x-rhino-attribute": {
              "name": "edit_mode",
              "readableName": "Edit Mode",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": false,
            "type": "boolean"
          },
          "current_edit_id": {
            "x-rhino-attribute": {
              "name": "current_edit_id",
              "readableName": "Current Edit",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "default": 0,
            "type": "integer"
          },
          "version_name": {
            "x-rhino-attribute": {
              "name": "version_name",
              "readableName": "Version Name",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": "base_version",
            "type": "string"
          },
          "ai_statuses": {
            "x-rhino-attribute": {
              "name": "ai_statuses",
              "readableName": "Ai Statuses",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "default": {
              "generation": 0,
              "edit": 0,
              "document_ingestion": 0,
              "generation_agents": {
                "project_manager": 0,
                "designer": 0,
                "architect": 0,
                "product_manager": 0,
                "ai_architect": 0,
                "trade_consultant": 0
              },
              "post_processing": {
                "scoping_estimator": 0,
                "market_sizing": 0,
                "interviewer": 0
              }
            },
            "type": "jsonb"
          },
          "ai_errors": {
            "x-rhino-attribute": {
              "name": "ai_errors",
              "readableName": "Ai Errors",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "default": {
              "generation": "",
              "edit": "",
              "document_ingestion": "",
              "generation_agents": {
                "project_manager": "",
                "designer": "",
                "architect": "",
                "product_manager": "",
                "ai_architect": "",
                "trade_consultant": ""
              },
              "post_processing": {
                "scoping_estimator": "",
                "market_sizing": "",
                "interviewer": ""
              }
            },
            "type": "jsonb"
          },
          "project_manager_reasoning": {
            "x-rhino-attribute": {
              "name": "project_manager_reasoning",
              "readableName": "Project Manager Reasoning",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": "",
            "type": "text"
          },
          "designer_reasoning": {
            "x-rhino-attribute": {
              "name": "designer_reasoning",
              "readableName": "Designer Reasoning",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": "",
            "type": "text"
          },
          "architect_reasoning": {
            "x-rhino-attribute": {
              "name": "architect_reasoning",
              "readableName": "Architect Reasoning",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": "",
            "type": "text"
          },
          "product_manager_reasoning": {
            "x-rhino-attribute": {
              "name": "product_manager_reasoning",
              "readableName": "Product Manager Reasoning",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": "",
            "type": "text"
          },
          "intake_profile": {
            "x-rhino-attribute": {
              "name": "intake_profile",
              "readableName": "Intake Profile",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": {
            },
            "type": "jsonb"
          },
          "ai_requirements": {
            "x-rhino-attribute": {
              "name": "ai_requirements",
              "readableName": "Ai Requirements",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": {
            },
            "type": "jsonb"
          },
          "ai_integration_requested": {
            "x-rhino-attribute": {
              "name": "ai_integration_requested",
              "readableName": "Ai Integration Requested",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": false,
            "type": "boolean"
          },
          "ai_integration_declined": {
            "x-rhino-attribute": {
              "name": "ai_integration_declined",
              "readableName": "Ai Integration Declined",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": false,
            "type": "boolean"
          },
          "ai_architect_score": {
            "x-rhino-attribute": {
              "name": "ai_architect_score",
              "readableName": "Ai Architect Score",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "default": 0,
            "type": "integer",
            "minimum": 0,
            "maximum": 10
          },
          "ai_architect_reasoning": {
            "x-rhino-attribute": {
              "name": "ai_architect_reasoning",
              "readableName": "Ai Architect Reasoning",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": "",
            "type": "text"
          },
          "design_system": {
            "x-rhino-attribute": {
              "name": "design_system",
              "readableName": "Design System",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": {
            },
            "type": "jsonb"
          },
          "rhino_runtime": {
            "x-rhino-attribute": {
              "name": "rhino_runtime",
              "readableName": "Rhino Runtime",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": true,
            "type": "string",
            "enum": [
              "v3",
              "v4"
            ]
          },
          "product_desk_approved": {
            "x-rhino-attribute": {
              "name": "product_desk_approved",
              "readableName": "Product Desk Approved",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": false,
            "type": "boolean"
          },
          "design_approved": {
            "x-rhino-attribute": {
              "name": "design_approved",
              "readableName": "Design Approved",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": false,
            "type": "boolean"
          },
          "prototype_approved": {
            "x-rhino-attribute": {
              "name": "prototype_approved",
              "readableName": "Prototype Approved",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": false,
            "type": "boolean"
          },
          "created_from_prd_proposal": {
            "x-rhino-attribute": {
              "name": "created_from_prd_proposal",
              "readableName": "Created From Prd Proposal",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": false,
            "type": "boolean"
          },
          "design_spec": {
            "x-rhino-attribute": {
              "name": "design_spec",
              "readableName": "Design Spec",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "default": {
            },
            "type": "jsonb"
          },
          "design_preferences": {
            "x-rhino-attribute": {
              "name": "design_preferences",
              "readableName": "Design Preferences",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "default": {
            },
            "type": "jsonb"
          },
          "is_trade_project": {
            "x-rhino-attribute": {
              "name": "is_trade_project",
              "readableName": "Is Trade Project",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": false,
            "type": "boolean"
          },
          "contractor_profile": {
            "x-rhino-attribute": {
              "name": "contractor_profile",
              "readableName": "Contractor Profile",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": {
            },
            "type": "jsonb"
          },
          "progress": {
            "x-rhino-attribute": {
              "name": "progress",
              "readableName": "Progress",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "default": {
            },
            "type": "jsonb"
          },
          "deploy_audit": {
            "x-rhino-attribute": {
              "name": "deploy_audit",
              "readableName": "Deploy Audit",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": true,
            "type": "jsonb"
          },
          "user_stories_total_count": {
            "x-rhino-attribute": {
              "name": "user_stories_total_count",
              "readableName": "User Stories Total Count",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": true,
            "default": 0,
            "type": "integer"
          },
          "story_point_table_total_count": {
            "x-rhino-attribute": {
              "name": "story_point_table_total_count",
              "readableName": "Story Point Table Total Count",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": true,
            "default": 0,
            "type": "integer"
          },
          "last_generation_run": {
            "x-rhino-attribute": {
              "name": "last_generation_run",
              "readableName": "Last Generation Run",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "default": {
            },
            "type": "jsonb"
          },
          "last_background_run": {
            "x-rhino-attribute": {
              "name": "last_background_run",
              "readableName": "Last Background Run",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "default": {
            },
            "type": "jsonb"
          },
          "product": {
            "x-rhino-attribute": {
              "name": "product",
              "readableName": "Product",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "type": "reference",
            "anyOf": [
              {
                "$ref": "#/components/schemas/product"
              }
            ]
          },
          "planning": {
            "x-rhino-attribute": {
              "name": "planning",
              "readableName": "Planning",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "reference",
            "anyOf": [
              {
                "$ref": "#/components/schemas/planning"
              }
            ]
          },
          "ui_prototype": {
            "x-rhino-attribute": {
              "name": "ui_prototype",
              "readableName": "Ui Prototype",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "reference",
            "anyOf": [
              {
                "$ref": "#/components/schemas/ui_prototype"
              }
            ]
          },
          "deployments": {
            "x-rhino-attribute": {
              "name": "deployments",
              "readableName": "Deployments",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": true,
            "type": "array",
            "items": {
              "type": "reference",
              "anyOf": [
                {
                  "$ref": "#/components/schemas/deployment"
                }
              ],
              "x-rhino-attribute-array": {
              }
            }
          }
        },
        "required": [
          "version_number",
          "is_editable",
          "elevator_pitch",
          "problem_statement",
          "solution",
          "key_features",
          "user_flows",
          "success_metrics",
          "competitors",
          "vision",
          "target_audience",
          "phasing",
          "design_principles",
          "user_personas",
          "user_journeys",
          "sitemap",
          "navigation_design",
          "description",
          "schema",
          "sample_data",
          "mermaid_erd_diagram",
          "user_stories",
          "project_manager_score",
          "designer_score",
          "architect_score",
          "product_manager_score",
          "story_point_table",
          "effort_by_role_summary",
          "total_days_without_rhino",
          "total_days_with_rhino",
          "time_estimated_without_rhino",
          "time_estimated_with_rhino",
          "estimate_generated",
          "industry_category",
          "geographic_scope",
          "tam_description",
          "tam_estimated_value_usd",
          "tam_estimation_basis",
          "tam_source",
          "sam_description",
          "sam_estimated_value_usd",
          "sam_estimation_basis",
          "sam_source",
          "som_description",
          "som_estimated_value_usd",
          "som_estimation_basis",
          "som_source",
          "avg_revenue_per_user_per_year",
          "expected_market_penetration_percent",
          "time_horizon_years",
          "customer_type",
          "pricing_model_basis",
          "key_competitors",
          "industry_growth_rate_cagr_percent",
          "advantage_summary",
          "market_sizing_generated",
          "edit_mode",
          "version_name",
          "project_manager_reasoning",
          "designer_reasoning",
          "architect_reasoning",
          "product_manager_reasoning",
          "intake_profile",
          "ai_requirements",
          "ai_integration_requested",
          "ai_integration_declined",
          "ai_architect_reasoning",
          "design_system",
          "product_desk_approved",
          "design_approved",
          "prototype_approved",
          "created_from_prd_proposal",
          "is_trade_project",
          "contractor_profile",
          "product"
        ]
      },
      "repository": {
        "x-rhino-model": {
          "model": "repository",
          "modelPlural": "repositories",
          "name": "repository",
          "pluralName": "repositories",
          "readableName": "Repository",
          "pluralReadableName": "Repositories",
          "ownedBy": "product",
          "singular": false,
          "path": "/api/repositories",
          "searchable": false
        },
        "type": "object",
        "properties": {
          "id": {
            "x-rhino-attribute": {
              "name": "id",
              "readableName": "Id",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "identifier"
          },
          "repo": {
            "x-rhino-attribute": {
              "name": "repo",
              "readableName": "Repo",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "string"
          },
          "created_at": {
            "x-rhino-attribute": {
              "name": "created_at",
              "readableName": "Created At",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "string",
            "format": "datetime"
          },
          "updated_at": {
            "x-rhino-attribute": {
              "name": "updated_at",
              "readableName": "Updated At",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "string",
            "format": "datetime"
          },
          "status": {
            "x-rhino-attribute": {
              "name": "status",
              "readableName": "Status",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "default": "initializing",
            "type": "string",
            "enum": [
              "initializing",
              "creating",
              "created",
              "installing_plan",
              "ready",
              "purging",
              "purged",
              "failed"
            ]
          },
          "org": {
            "x-rhino-attribute": {
              "name": "org",
              "readableName": "Org",
              "readable": true,
              "creatable": true,
              "updatable": false
            },
            "nullable": false,
            "type": "string"
          },
          "internal": {
            "x-rhino-attribute": {
              "name": "internal",
              "readableName": "Internal",
              "readable": true,
              "creatable": true,
              "updatable": false
            },
            "nullable": false,
            "default": true,
            "type": "boolean"
          },
          "source_tag": {
            "x-rhino-attribute": {
              "name": "source_tag",
              "readableName": "Source Tag",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": "main",
            "type": "string"
          },
          "repo_in_user_org": {
            "x-rhino-attribute": {
              "name": "repo_in_user_org",
              "readableName": "Repo In User Org",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "default": false,
            "type": "boolean"
          },
          "repo_invitation_status": {
            "x-rhino-attribute": {
              "name": "repo_invitation_status",
              "readableName": "Repo Invitation Status",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": "not_invited",
            "type": "string",
            "enum": [
              "not_invited",
              "sent",
              "error"
            ]
          },
          "type": {
            "x-rhino-attribute": {
              "name": "type",
              "readableName": "Type",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": "BackendRepository",
            "type": "string"
          },
          "github_repo": {
            "x-rhino-attribute": {
              "name": "github_repo",
              "readableName": "Github Repo",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "string"
          },
          "github_url": {
            "x-rhino-attribute": {
              "name": "github_url",
              "readableName": "Github Url",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "string"
          },
          "product": {
            "x-rhino-attribute": {
              "name": "product",
              "readableName": "Product",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "reference",
            "anyOf": [
              {
                "$ref": "#/components/schemas/product"
              }
            ]
          },
          "live_dev": {
            "x-rhino-attribute": {
              "name": "live_dev",
              "readableName": "Live Dev",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "reference",
            "anyOf": [
              {
                "$ref": "#/components/schemas/live_dev"
              }
            ]
          },
          "cloned_repository": {
            "x-rhino-attribute": {
              "name": "cloned_repository",
              "readableName": "Cloned Repository",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "reference",
            "anyOf": [
              {
                "$ref": "#/components/schemas/cloned_repository"
              }
            ]
          }
        },
        "required": [
          "org",
          "internal",
          "source_tag",
          "repo_invitation_status",
          "type"
        ]
      },
      "variable": {
        "x-rhino-model": {
          "model": "variable",
          "modelPlural": "variables",
          "name": "variable",
          "pluralName": "variables",
          "readableName": "Variable",
          "pluralReadableName": "Variables",
          "ownedBy": "plugin",
          "singular": false,
          "path": "/api/variables",
          "searchable": false
        },
        "type": "object",
        "properties": {
          "id": {
            "x-rhino-attribute": {
              "name": "id",
              "readableName": "Id",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "identifier"
          },
          "name": {
            "x-rhino-attribute": {
              "name": "name",
              "readableName": "Name",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "type": "string"
          },
          "created_at": {
            "x-rhino-attribute": {
              "name": "created_at",
              "readableName": "Created At",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "string",
            "format": "datetime"
          },
          "updated_at": {
            "x-rhino-attribute": {
              "name": "updated_at",
              "readableName": "Updated At",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "string",
            "format": "datetime"
          },
          "plugin": {
            "x-rhino-attribute": {
              "name": "plugin",
              "readableName": "Plugin",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "type": "reference",
            "anyOf": [
              {
                "$ref": "#/components/schemas/plugin"
              }
            ]
          }
        },
        "required": [
          "name",
          "plugin"
        ]
      },
      "deployment": {
        "x-rhino-model": {
          "model": "deployment",
          "modelPlural": "deployments",
          "name": "deployment",
          "pluralName": "deployments",
          "readableName": "Deployment",
          "pluralReadableName": "Deployments",
          "ownedBy": "prd",
          "singular": false,
          "path": "/api/deployments",
          "searchable": false
        },
        "type": "object",
        "properties": {
          "id": {
            "x-rhino-attribute": {
              "name": "id",
              "readableName": "Id",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "identifier"
          },
          "deployable_type": {
            "x-rhino-attribute": {
              "name": "deployable_type",
              "readableName": "Deployable Type",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "type": "string"
          },
          "environment": {
            "x-rhino-attribute": {
              "name": "environment",
              "readableName": "Environment",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": "staging",
            "type": "string",
            "enum": [
              "staging",
              "production"
            ]
          },
          "created_at": {
            "x-rhino-attribute": {
              "name": "created_at",
              "readableName": "Created At",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "string",
            "format": "datetime"
          },
          "updated_at": {
            "x-rhino-attribute": {
              "name": "updated_at",
              "readableName": "Updated At",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "string",
            "format": "datetime"
          },
          "status": {
            "x-rhino-attribute": {
              "name": "status",
              "readableName": "Status",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": "idle",
            "type": "string",
            "enum": [
              "idle",
              "in_progress",
              "failed",
              "successful"
            ]
          },
          "error_message": {
            "x-rhino-attribute": {
              "name": "error_message",
              "readableName": "Error Message",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "text"
          },
          "changes_pending": {
            "x-rhino-attribute": {
              "name": "changes_pending",
              "readableName": "Changes Pending",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": false,
            "type": "boolean"
          },
          "deletion_scheduled_at": {
            "x-rhino-attribute": {
              "name": "deletion_scheduled_at",
              "readableName": "Deletion Scheduled At",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "string",
            "format": "datetime"
          },
          "paused_at": {
            "x-rhino-attribute": {
              "name": "paused_at",
              "readableName": "Paused At",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "string",
            "format": "datetime"
          },
          "paused_formation": {
            "x-rhino-attribute": {
              "name": "paused_formation",
              "readableName": "Paused Formation",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "jsonb"
          },
          "github_integration_action": {
            "x-rhino-attribute": {
              "name": "github_integration_action",
              "readableName": "Github Integration Action",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": true,
            "type": "string"
          },
          "front_end_url": {
            "x-rhino-attribute": {
              "name": "front_end_url",
              "readableName": "Front End Url",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "string"
          },
          "back_end_url": {
            "x-rhino-attribute": {
              "name": "back_end_url",
              "readableName": "Back End Url",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "string"
          },
          "region_name": {
            "x-rhino-attribute": {
              "name": "region_name",
              "readableName": "Region Name",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "string"
          },
          "provider": {
            "x-rhino-attribute": {
              "name": "provider",
              "readableName": "Provider",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "string"
          },
          "prd": {
            "x-rhino-attribute": {
              "name": "prd",
              "readableName": "Prd",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "reference",
            "anyOf": [
              {
                "$ref": "#/components/schemas/prd"
              }
            ]
          },
          "deployable": {
            "x-rhino-attribute": {
              "name": "deployable",
              "readableName": "Deployable",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "type": "reference",
            "anyOf": [
              {
                "$ref": "#/components/schemas/google_cloud_deployment"
              },
              {
                "$ref": "#/components/schemas/heroku_deployment"
              },
              {
                "$ref": "#/components/schemas/aws_deployment"
              },
              {
                "$ref": "#/components/schemas/render_deployment"
              }
            ]
          }
        },
        "required": [
          "deployable_type",
          "environment",
          "status",
          "changes_pending",
          "deployable"
        ]
      },
      "google_cloud_region": {
        "x-rhino-model": {
          "model": "google_cloud_region",
          "modelPlural": "google_cloud/regions",
          "name": "googleCloud::Region",
          "pluralName": "googleCloud::Regions",
          "readableName": "Region",
          "pluralReadableName": "Regions",
          "ownedBy": "global",
          "singular": false,
          "path": "/api/google_cloud_regions",
          "searchable": false
        },
        "type": "object",
        "properties": {
          "id": {
            "x-rhino-attribute": {
              "name": "id",
              "readableName": "Id",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "identifier"
          },
          "gc_name": {
            "x-rhino-attribute": {
              "name": "gc_name",
              "readableName": "Gc Name",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "type": "string"
          },
          "created_at": {
            "x-rhino-attribute": {
              "name": "created_at",
              "readableName": "Created At",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "string",
            "format": "datetime"
          },
          "updated_at": {
            "x-rhino-attribute": {
              "name": "updated_at",
              "readableName": "Updated At",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "string",
            "format": "datetime"
          }
        },
        "required": [
          "gc_name"
        ]
      },
      "google_cloud_deployment": {
        "x-rhino-model": {
          "model": "google_cloud_deployment",
          "modelPlural": "google_cloud/deployments",
          "name": "googleCloud::Deployment",
          "pluralName": "googleCloud::Deployments",
          "readableName": "Deployment",
          "pluralReadableName": "Deployments",
          "ownedBy": "deployment",
          "singular": false,
          "path": "/api/google_cloud_deployments",
          "searchable": false
        },
        "type": "object",
        "properties": {
          "id": {
            "x-rhino-attribute": {
              "name": "id",
              "readableName": "Id",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "identifier"
          },
          "gc_trigger_id": {
            "x-rhino-attribute": {
              "name": "gc_trigger_id",
              "readableName": "Gc Trigger",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": true,
            "type": "string"
          },
          "created_at": {
            "x-rhino-attribute": {
              "name": "created_at",
              "readableName": "Created At",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "string",
            "format": "datetime"
          },
          "updated_at": {
            "x-rhino-attribute": {
              "name": "updated_at",
              "readableName": "Updated At",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "string",
            "format": "datetime"
          },
          "deployment": {
            "x-rhino-attribute": {
              "name": "deployment",
              "readableName": "Deployment",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": true,
            "type": "reference",
            "anyOf": [
              {
                "$ref": "#/components/schemas/deployment"
              }
            ]
          },
          "region": {
            "x-rhino-attribute": {
              "name": "region",
              "readableName": "Region",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "type": "reference",
            "anyOf": [
              {
                "$ref": "#/components/schemas/google_cloud_region"
              }
            ]
          },
          "environment": {
            "x-rhino-attribute": {
              "name": "environment",
              "readableName": "Environment",
              "readable": false,
              "creatable": true,
              "updatable": true
            },
            "writeOnly": true,
            "nullable": true,
            "type": "unknown"
          }
        },
        "required": [
          "region"
        ]
      },
      "heroku_deployment": {
        "x-rhino-model": {
          "model": "heroku_deployment",
          "modelPlural": "heroku/deployments",
          "name": "heroku::Deployment",
          "pluralName": "heroku::Deployments",
          "readableName": "Deployment",
          "pluralReadableName": "Deployments",
          "ownedBy": "deployment",
          "singular": false,
          "path": "/api/heroku_deployments",
          "searchable": false
        },
        "type": "object",
        "properties": {
          "id": {
            "x-rhino-attribute": {
              "name": "id",
              "readableName": "Id",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "identifier"
          },
          "created_at": {
            "x-rhino-attribute": {
              "name": "created_at",
              "readableName": "Created At",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "string",
            "format": "datetime"
          },
          "updated_at": {
            "x-rhino-attribute": {
              "name": "updated_at",
              "readableName": "Updated At",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "string",
            "format": "datetime"
          },
          "team": {
            "x-rhino-attribute": {
              "name": "team",
              "readableName": "Team",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "type": "string"
          },
          "internal": {
            "x-rhino-attribute": {
              "name": "internal",
              "readableName": "Internal",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "default": true,
            "type": "boolean"
          },
          "deployment": {
            "x-rhino-attribute": {
              "name": "deployment",
              "readableName": "Deployment",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "reference",
            "anyOf": [
              {
                "$ref": "#/components/schemas/deployment"
              }
            ]
          }
        },
        "required": [
          "team"
        ]
      },
      "aws_setup": {
        "x-rhino-model": {
          "model": "aws_setup",
          "modelPlural": "aws/setups",
          "name": "aws::Setup",
          "pluralName": "aws::Setups",
          "readableName": "Setup",
          "pluralReadableName": "Setups",
          "ownedBy": "organization",
          "singular": false,
          "path": "/api/aws_setups",
          "searchable": false
        },
        "type": "object",
        "properties": {
          "id": {
            "x-rhino-attribute": {
              "name": "id",
              "readableName": "Id",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "identifier"
          },
          "account_id": {
            "x-rhino-attribute": {
              "name": "account_id",
              "readableName": "Account",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "type": "string"
          },
          "permissions_checked": {
            "x-rhino-attribute": {
              "name": "permissions_checked",
              "readableName": "Permissions Checked",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": false,
            "type": "boolean"
          },
          "created_at": {
            "x-rhino-attribute": {
              "name": "created_at",
              "readableName": "Created At",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "string",
            "format": "datetime"
          },
          "updated_at": {
            "x-rhino-attribute": {
              "name": "updated_at",
              "readableName": "Updated At",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "string",
            "format": "datetime"
          },
          "external_id": {
            "x-rhino-attribute": {
              "name": "external_id",
              "readableName": "External",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "type": "uuid"
          },
          "organization": {
            "x-rhino-attribute": {
              "name": "organization",
              "readableName": "Organization",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "type": "reference",
            "anyOf": [
              {
                "$ref": "#/components/schemas/organization"
              }
            ]
          }
        },
        "required": [
          "account_id",
          "permissions_checked",
          "external_id",
          "organization"
        ]
      },
      "aws_resource": {
        "x-rhino-model": {
          "model": "aws_resource",
          "modelPlural": "aws/resources",
          "name": "aws::Resource",
          "pluralName": "aws::Resources",
          "readableName": "Resource",
          "pluralReadableName": "Resources",
          "ownedBy": "aws_deployment",
          "singular": false,
          "path": "/api/aws_resources",
          "searchable": false
        },
        "type": "object",
        "properties": {
          "id": {
            "x-rhino-attribute": {
              "name": "id",
              "readableName": "Id",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "identifier"
          },
          "aws_iam_role_arn": {
            "x-rhino-attribute": {
              "name": "aws_iam_role_arn",
              "readableName": "Aws Iam Role Arn",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "string"
          },
          "oidc_provider_arn": {
            "x-rhino-attribute": {
              "name": "oidc_provider_arn",
              "readableName": "Oidc Provider Arn",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "string"
          },
          "rds_endpoint": {
            "x-rhino-attribute": {
              "name": "rds_endpoint",
              "readableName": "Rds Endpoint",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "string"
          },
          "rds_port": {
            "x-rhino-attribute": {
              "name": "rds_port",
              "readableName": "Rds Port",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "string"
          },
          "rds_database_name": {
            "x-rhino-attribute": {
              "name": "rds_database_name",
              "readableName": "Rds Database Name",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "string"
          },
          "rds_password_secret_arn": {
            "x-rhino-attribute": {
              "name": "rds_password_secret_arn",
              "readableName": "Rds Password Secret Arn",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "string"
          },
          "rds_instance_identifier": {
            "x-rhino-attribute": {
              "name": "rds_instance_identifier",
              "readableName": "Rds Instance Identifier",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "string"
          },
          "ecs_cluster_name": {
            "x-rhino-attribute": {
              "name": "ecs_cluster_name",
              "readableName": "Ecs Cluster Name",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "string"
          },
          "ecs_service_name": {
            "x-rhino-attribute": {
              "name": "ecs_service_name",
              "readableName": "Ecs Service Name",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "string"
          },
          "ecs_task_definition_arn": {
            "x-rhino-attribute": {
              "name": "ecs_task_definition_arn",
              "readableName": "Ecs Task Definition Arn",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "string"
          },
          "ecs_task_definition_family": {
            "x-rhino-attribute": {
              "name": "ecs_task_definition_family",
              "readableName": "Ecs Task Definition Family",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "string"
          },
          "ec2_public_ip": {
            "x-rhino-attribute": {
              "name": "ec2_public_ip",
              "readableName": "Ec2 Public Ip",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "string"
          },
          "ec2_public_url": {
            "x-rhino-attribute": {
              "name": "ec2_public_url",
              "readableName": "Ec2 Public Url",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "string"
          },
          "ec2_instance_id": {
            "x-rhino-attribute": {
              "name": "ec2_instance_id",
              "readableName": "Ec2 Instance",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "string"
          },
          "secret_key_base_secret_arn": {
            "x-rhino-attribute": {
              "name": "secret_key_base_secret_arn",
              "readableName": "Secret Key Base Secret Arn",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "string"
          },
          "iam_policy_name": {
            "x-rhino-attribute": {
              "name": "iam_policy_name",
              "readableName": "Iam Policy Name",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "string"
          },
          "resource_name": {
            "x-rhino-attribute": {
              "name": "resource_name",
              "readableName": "Resource Name",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "string"
          },
          "github_repo": {
            "x-rhino-attribute": {
              "name": "github_repo",
              "readableName": "Github Repo",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "string"
          },
          "aws_region": {
            "x-rhino-attribute": {
              "name": "aws_region",
              "readableName": "Aws Region",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "default": "us-east-1",
            "type": "string"
          },
          "created_at": {
            "x-rhino-attribute": {
              "name": "created_at",
              "readableName": "Created At",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "string",
            "format": "datetime"
          },
          "updated_at": {
            "x-rhino-attribute": {
              "name": "updated_at",
              "readableName": "Updated At",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "string",
            "format": "datetime"
          },
          "discarded_at": {
            "x-rhino-attribute": {
              "name": "discarded_at",
              "readableName": "Discarded At",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "string",
            "format": "datetime"
          },
          "aws_deployment": {
            "x-rhino-attribute": {
              "name": "aws_deployment",
              "readableName": "Aws Deployment",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "type": "reference",
            "anyOf": [
              {
                "$ref": "#/components/schemas/aws_deployment"
              }
            ]
          }
        },
        "required": [
          "aws_deployment"
        ]
      },
      "aws_deployment": {
        "x-rhino-model": {
          "model": "aws_deployment",
          "modelPlural": "aws/deployments",
          "name": "aws::Deployment",
          "pluralName": "aws::Deployments",
          "readableName": "Deployment",
          "pluralReadableName": "Deployments",
          "ownedBy": "deployment",
          "singular": false,
          "path": "/api/aws_deployments",
          "searchable": false
        },
        "type": "object",
        "properties": {
          "id": {
            "x-rhino-attribute": {
              "name": "id",
              "readableName": "Id",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "identifier"
          },
          "created_at": {
            "x-rhino-attribute": {
              "name": "created_at",
              "readableName": "Created At",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "string",
            "format": "datetime"
          },
          "updated_at": {
            "x-rhino-attribute": {
              "name": "updated_at",
              "readableName": "Updated At",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "string",
            "format": "datetime"
          },
          "discarded_at": {
            "x-rhino-attribute": {
              "name": "discarded_at",
              "readableName": "Discarded At",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": true,
            "type": "string",
            "format": "datetime"
          },
          "deployment": {
            "x-rhino-attribute": {
              "name": "deployment",
              "readableName": "Deployment",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": true,
            "type": "reference",
            "anyOf": [
              {
                "$ref": "#/components/schemas/deployment"
              }
            ]
          },
          "aws_setup": {
            "x-rhino-attribute": {
              "name": "aws_setup",
              "readableName": "Aws Setup",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "reference",
            "anyOf": [
              {
                "$ref": "#/components/schemas/aws_setup"
              }
            ]
          },
          "aws_resource": {
            "x-rhino-attribute": {
              "name": "aws_resource",
              "readableName": "Aws Resource",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": true,
            "type": "reference",
            "anyOf": [
              {
                "$ref": "#/components/schemas/aws_resource"
              }
            ]
          },
          "environment": {
            "x-rhino-attribute": {
              "name": "environment",
              "readableName": "Environment",
              "readable": false,
              "creatable": true,
              "updatable": true
            },
            "writeOnly": true,
            "nullable": true,
            "type": "unknown"
          }
        }
      },
      "render_deployment": {
        "x-rhino-model": {
          "model": "render_deployment",
          "modelPlural": "render/deployments",
          "name": "render::Deployment",
          "pluralName": "render::Deployments",
          "readableName": "Deployment",
          "pluralReadableName": "Deployments",
          "ownedBy": "deployment",
          "singular": false,
          "path": "/api/render_deployments",
          "searchable": false
        },
        "type": "object",
        "properties": {
          "id": {
            "x-rhino-attribute": {
              "name": "id",
              "readableName": "Id",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "identifier"
          },
          "service_id": {
            "x-rhino-attribute": {
              "name": "service_id",
              "readableName": "Service",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": true,
            "type": "string"
          },
          "postgres_id": {
            "x-rhino-attribute": {
              "name": "postgres_id",
              "readableName": "Postgres",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": true,
            "type": "string"
          },
          "deploy_id": {
            "x-rhino-attribute": {
              "name": "deploy_id",
              "readableName": "Deploy",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": true,
            "type": "string"
          },
          "service_url": {
            "x-rhino-attribute": {
              "name": "service_url",
              "readableName": "Service Url",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": true,
            "type": "string"
          },
          "region": {
            "x-rhino-attribute": {
              "name": "region",
              "readableName": "Region",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": "ohio",
            "type": "string"
          },
          "plan": {
            "x-rhino-attribute": {
              "name": "plan",
              "readableName": "Plan",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": "free",
            "type": "string"
          },
          "postgres_plan": {
            "x-rhino-attribute": {
              "name": "postgres_plan",
              "readableName": "Postgres Plan",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": "basic-256mb",
            "type": "string"
          },
          "created_at": {
            "x-rhino-attribute": {
              "name": "created_at",
              "readableName": "Created At",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "string",
            "format": "datetime"
          },
          "updated_at": {
            "x-rhino-attribute": {
              "name": "updated_at",
              "readableName": "Updated At",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "string",
            "format": "datetime"
          },
          "owner_id": {
            "x-rhino-attribute": {
              "name": "owner_id",
              "readableName": "Owner",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": true,
            "type": "string"
          },
          "deployment": {
            "x-rhino-attribute": {
              "name": "deployment",
              "readableName": "Deployment",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "reference",
            "anyOf": [
              {
                "$ref": "#/components/schemas/deployment"
              }
            ]
          }
        },
        "required": [
          "region",
          "plan",
          "postgres_plan"
        ]
      },
      "ai_model": {
        "x-rhino-model": {
          "model": "ai_model",
          "modelPlural": "ai_models",
          "name": "aiModel",
          "pluralName": "aiModels",
          "readableName": "Ai model",
          "pluralReadableName": "Ai models",
          "ownedBy": "global",
          "singular": false,
          "path": "/api/ai_models",
          "searchable": true
        },
        "type": "object",
        "properties": {
          "id": {
            "x-rhino-attribute": {
              "name": "id",
              "readableName": "Id",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "identifier"
          },
          "name": {
            "x-rhino-attribute": {
              "name": "name",
              "readableName": "Name",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "type": "string"
          },
          "slug": {
            "x-rhino-attribute": {
              "name": "slug",
              "readableName": "Slug",
              "readable": false,
              "creatable": true,
              "updatable": true
            },
            "writeOnly": true,
            "nullable": false,
            "type": "string"
          },
          "uri_base": {
            "x-rhino-attribute": {
              "name": "uri_base",
              "readableName": "Uri Base",
              "readable": false,
              "creatable": true,
              "updatable": true
            },
            "writeOnly": true,
            "nullable": false,
            "default": "https://api.openai.com/v1/",
            "type": "string"
          },
          "env_key": {
            "x-rhino-attribute": {
              "name": "env_key",
              "readableName": "Env Key",
              "readable": false,
              "creatable": true,
              "updatable": true
            },
            "writeOnly": true,
            "nullable": false,
            "default": "OPENAI_ACCESS_TOKEN",
            "type": "string"
          },
          "tool_use": {
            "x-rhino-attribute": {
              "name": "tool_use",
              "readableName": "Tool Use",
              "readable": false,
              "creatable": true,
              "updatable": true
            },
            "writeOnly": true,
            "nullable": true,
            "default": true,
            "type": "boolean"
          },
          "provider": {
            "x-rhino-attribute": {
              "name": "provider",
              "readableName": "Provider",
              "readable": false,
              "creatable": true,
              "updatable": true
            },
            "writeOnly": true,
            "nullable": true,
            "type": "string"
          },
          "capabilities": {
            "x-rhino-attribute": {
              "name": "capabilities",
              "readableName": "Capabilities",
              "readable": false,
              "creatable": true,
              "updatable": true
            },
            "writeOnly": true,
            "nullable": false,
            "default": {
            },
            "type": "jsonb"
          },
          "openhands_model": {
            "x-rhino-attribute": {
              "name": "openhands_model",
              "readableName": "Openhands Model",
              "readable": false,
              "creatable": true,
              "updatable": true
            },
            "writeOnly": true,
            "nullable": true,
            "type": "string"
          },
          "display_order": {
            "x-rhino-attribute": {
              "name": "display_order",
              "readableName": "Display Order",
              "readable": false,
              "creatable": true,
              "updatable": true
            },
            "writeOnly": true,
            "nullable": false,
            "default": 0,
            "type": "integer"
          },
          "description": {
            "x-rhino-attribute": {
              "name": "description",
              "readableName": "Description",
              "readable": false,
              "creatable": true,
              "updatable": true
            },
            "writeOnly": true,
            "nullable": true,
            "type": "text"
          },
          "warning_text": {
            "x-rhino-attribute": {
              "name": "warning_text",
              "readableName": "Warning Text",
              "readable": false,
              "creatable": true,
              "updatable": true
            },
            "writeOnly": true,
            "nullable": true,
            "type": "text"
          },
          "user_selectable": {
            "x-rhino-attribute": {
              "name": "user_selectable",
              "readableName": "User Selectable",
              "readable": false,
              "creatable": true,
              "updatable": true
            },
            "writeOnly": true,
            "nullable": false,
            "default": false,
            "type": "boolean"
          }
        },
        "required": [
          "name",
          "slug",
          "uri_base",
          "env_key",
          "capabilities",
          "display_order",
          "user_selectable"
        ]
      },
      "ai_history": {
        "x-rhino-model": {
          "model": "ai_history",
          "modelPlural": "ai_histories",
          "name": "aiHistory",
          "pluralName": "aiHistories",
          "readableName": "Ai history",
          "pluralReadableName": "Ai histories",
          "ownedBy": "chatable",
          "singular": false,
          "path": "/api/ai_histories",
          "searchable": false
        },
        "type": "object",
        "properties": {
          "id": {
            "x-rhino-attribute": {
              "name": "id",
              "readableName": "Id",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "identifier"
          },
          "visible_messages": {
            "x-rhino-attribute": {
              "name": "visible_messages",
              "readableName": "Visible Messages",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": true,
            "default": [

            ],
            "type": "jsonb"
          }
        }
      },
      "ui_prototype": {
        "x-rhino-model": {
          "model": "ui_prototype",
          "modelPlural": "ui_prototypes",
          "name": "uiPrototype",
          "pluralName": "uiPrototypes",
          "readableName": "Ui prototype",
          "pluralReadableName": "Ui prototypes",
          "ownedBy": "prd",
          "singular": false,
          "path": "/api/ui_prototypes",
          "searchable": false
        },
        "type": "object",
        "properties": {
          "id": {
            "x-rhino-attribute": {
              "name": "id",
              "readableName": "Id",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "identifier"
          },
          "prd_id": {
            "x-rhino-attribute": {
              "name": "prd_id",
              "readableName": "Prd",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "integer"
          },
          "metadata": {
            "x-rhino-attribute": {
              "name": "metadata",
              "readableName": "Metadata",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": true,
            "type": "jsonb"
          },
          "dependencies": {
            "x-rhino-attribute": {
              "name": "dependencies",
              "readableName": "Dependencies",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": true,
            "default": {
            },
            "type": "jsonb"
          },
          "created_at": {
            "x-rhino-attribute": {
              "name": "created_at",
              "readableName": "Created At",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "string",
            "format": "datetime"
          },
          "updated_at": {
            "x-rhino-attribute": {
              "name": "updated_at",
              "readableName": "Updated At",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "string",
            "format": "datetime"
          },
          "ai_status": {
            "x-rhino-attribute": {
              "name": "ai_status",
              "readableName": "Ai Status",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "default": "idle",
            "type": "string",
            "enum": [
              "idle",
              "busy",
              "error"
            ]
          },
          "ai_error": {
            "x-rhino-attribute": {
              "name": "ai_error",
              "readableName": "Ai Error",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "default": "",
            "type": "text"
          },
          "runtime_error": {
            "x-rhino-attribute": {
              "name": "runtime_error",
              "readableName": "Runtime Error",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": false,
            "type": "boolean"
          },
          "ai_history": {
            "x-rhino-attribute": {
              "name": "ai_history",
              "readableName": "Ai History",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": true,
            "type": "reference",
            "anyOf": [
              {
                "$ref": "#/components/schemas/ai_history"
              }
            ]
          },
          "prd_content_fingerprint": {
            "x-rhino-attribute": {
              "name": "prd_content_fingerprint",
              "readableName": "Prd Content Fingerprint",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": true,
            "type": "string"
          },
          "max_ui_pages_at_generation": {
            "x-rhino-attribute": {
              "name": "max_ui_pages_at_generation",
              "readableName": "Max Ui Pages At Generation",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": true,
            "type": "integer"
          },
          "is_stale": {
            "x-rhino-attribute": {
              "name": "is_stale",
              "readableName": "Is Stale",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": true,
            "default": false,
            "type": "boolean"
          },
          "stale_reasons": {
            "x-rhino-attribute": {
              "name": "stale_reasons",
              "readableName": "Stale Reasons",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": true,
            "default": [

            ],
            "type": "jsonb"
          },
          "user_edited_paths": {
            "x-rhino-attribute": {
              "name": "user_edited_paths",
              "readableName": "User Edited Paths",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": true,
            "type": "jsonb"
          },
          "legacy_heroui_prototype": {
            "x-rhino-attribute": {
              "name": "legacy_heroui_prototype",
              "readableName": "Legacy Heroui Prototype",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": true,
            "default": false,
            "type": "boolean"
          },
          "has_locked_pages": {
            "x-rhino-attribute": {
              "name": "has_locked_pages",
              "readableName": "Has Locked Pages",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": true,
            "default": false,
            "type": "boolean"
          },
          "locked_pages_count": {
            "x-rhino-attribute": {
              "name": "locked_pages_count",
              "readableName": "Locked Pages Count",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": true,
            "default": 0,
            "type": "integer"
          },
          "plan_upgrade_unlock_available": {
            "x-rhino-attribute": {
              "name": "plan_upgrade_unlock_available",
              "readableName": "Plan Upgrade Unlock Available",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": true,
            "default": false,
            "type": "boolean"
          },
          "source_prd_snapshot": {
            "x-rhino-attribute": {
              "name": "source_prd_snapshot",
              "readableName": "Source Prd Snapshot",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "default": {
            },
            "type": "jsonb"
          },
          "last_diff_summary": {
            "x-rhino-attribute": {
              "name": "last_diff_summary",
              "readableName": "Last Diff Summary",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "default": {
            },
            "type": "jsonb"
          },
          "last_generation_run": {
            "x-rhino-attribute": {
              "name": "last_generation_run",
              "readableName": "Last Generation Run",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": true,
            "default": {
            },
            "type": "jsonb"
          },
          "design_gate": {
            "x-rhino-attribute": {
              "name": "design_gate",
              "readableName": "Design Gate",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "default": "ungated",
            "type": "string",
            "enum": [
              "ungated",
              "awaiting",
              "passed"
            ]
          },
          "restyle_available": {
            "x-rhino-attribute": {
              "name": "restyle_available",
              "readableName": "Restyle Available",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": true,
            "default": false,
            "type": "boolean"
          },
          "prd_sync_receipts": {
            "x-rhino-attribute": {
              "name": "prd_sync_receipts",
              "readableName": "Prd Sync Receipts",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "default": {
            },
            "type": "jsonb"
          }
        },
        "required": [
          "runtime_error"
        ]
      },
      "product_role": {
        "x-rhino-model": {
          "model": "product_role",
          "modelPlural": "product_roles",
          "name": "productRole",
          "pluralName": "productRoles",
          "readableName": "Product role",
          "pluralReadableName": "Product roles",
          "ownedBy": "product",
          "singular": false,
          "path": "/api/product_roles",
          "searchable": false
        },
        "type": "object",
        "properties": {
          "id": {
            "x-rhino-attribute": {
              "name": "id",
              "readableName": "Id",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "identifier"
          },
          "name": {
            "x-rhino-attribute": {
              "name": "name",
              "readableName": "Name",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "string"
          },
          "created_at": {
            "x-rhino-attribute": {
              "name": "created_at",
              "readableName": "Created At",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "string",
            "format": "datetime"
          },
          "updated_at": {
            "x-rhino-attribute": {
              "name": "updated_at",
              "readableName": "Updated At",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "string",
            "format": "datetime"
          },
          "product": {
            "x-rhino-attribute": {
              "name": "product",
              "readableName": "Product",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "type": "reference",
            "anyOf": [
              {
                "$ref": "#/components/schemas/product"
              }
            ]
          }
        },
        "required": [
          "product"
        ]
      },
      "product_story": {
        "x-rhino-model": {
          "model": "product_story",
          "modelPlural": "product_stories",
          "name": "productStory",
          "pluralName": "productStories",
          "readableName": "Product story",
          "pluralReadableName": "Product stories",
          "ownedBy": "product_role",
          "singular": false,
          "path": "/api/product_stories",
          "searchable": false
        },
        "type": "object",
        "properties": {
          "id": {
            "x-rhino-attribute": {
              "name": "id",
              "readableName": "Id",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "identifier"
          },
          "title": {
            "x-rhino-attribute": {
              "name": "title",
              "readableName": "Title",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "type": "string"
          },
          "as_a": {
            "x-rhino-attribute": {
              "name": "as_a",
              "readableName": "As A",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "type": "string"
          },
          "i_want": {
            "x-rhino-attribute": {
              "name": "i_want",
              "readableName": "I Want",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "type": "string"
          },
          "so_that": {
            "x-rhino-attribute": {
              "name": "so_that",
              "readableName": "So That",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "type": "string"
          },
          "acceptance_criteria": {
            "x-rhino-attribute": {
              "name": "acceptance_criteria",
              "readableName": "Acceptance Criteria",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "default": [

            ],
            "type": "array",
            "items": {
              "type": "string"
            }
          },
          "created_at": {
            "x-rhino-attribute": {
              "name": "created_at",
              "readableName": "Created At",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "string",
            "format": "datetime"
          },
          "updated_at": {
            "x-rhino-attribute": {
              "name": "updated_at",
              "readableName": "Updated At",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "string",
            "format": "datetime"
          },
          "product_role": {
            "x-rhino-attribute": {
              "name": "product_role",
              "readableName": "Product Role",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "type": "reference",
            "anyOf": [
              {
                "$ref": "#/components/schemas/product_role"
              }
            ]
          }
        },
        "required": [
          "title",
          "as_a",
          "i_want",
          "so_that",
          "product_role"
        ]
      },
      "product_template": {
        "x-rhino-model": {
          "model": "product_template",
          "modelPlural": "product_templates",
          "name": "productTemplate",
          "pluralName": "productTemplates",
          "readableName": "Product template",
          "pluralReadableName": "Product templates",
          "ownedBy": "organization",
          "singular": false,
          "path": "/api/product_templates",
          "searchable": true
        },
        "type": "object",
        "properties": {
          "id": {
            "x-rhino-attribute": {
              "name": "id",
              "readableName": "Id",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "identifier"
          },
          "name": {
            "x-rhino-attribute": {
              "name": "name",
              "readableName": "Name",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "type": "string"
          },
          "description": {
            "x-rhino-attribute": {
              "name": "description",
              "readableName": "Description",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "type": "text"
          },
          "slug": {
            "x-rhino-attribute": {
              "name": "slug",
              "readableName": "Slug",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "type": "string"
          },
          "icon": {
            "x-rhino-attribute": {
              "name": "icon",
              "readableName": "Icon",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "type": "string"
          },
          "product": {
            "x-rhino-attribute": {
              "name": "product",
              "readableName": "Product",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "type": "jsonb"
          },
          "created_at": {
            "x-rhino-attribute": {
              "name": "created_at",
              "readableName": "Created At",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "string",
            "format": "datetime"
          },
          "updated_at": {
            "x-rhino-attribute": {
              "name": "updated_at",
              "readableName": "Updated At",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "string",
            "format": "datetime"
          },
          "marketplace": {
            "x-rhino-attribute": {
              "name": "marketplace",
              "readableName": "Marketplace",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": false,
            "type": "boolean"
          },
          "discarded_at": {
            "x-rhino-attribute": {
              "name": "discarded_at",
              "readableName": "Discarded At",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "string",
            "format": "datetime"
          },
          "organization": {
            "x-rhino-attribute": {
              "name": "organization",
              "readableName": "Organization",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "reference",
            "anyOf": [
              {
                "$ref": "#/components/schemas/organization"
              }
            ]
          }
        },
        "required": [
          "name",
          "description",
          "slug",
          "icon",
          "product",
          "marketplace"
        ]
      },
      "product_template_marketplace": {
        "x-rhino-model": {
          "model": "product_template_marketplace",
          "modelPlural": "product_template_marketplaces",
          "name": "productTemplateMarketplace",
          "pluralName": "productTemplateMarketplaces",
          "readableName": "Product template marketplace",
          "pluralReadableName": "Product template marketplaces",
          "ownedBy": "global",
          "singular": false,
          "path": "/api/product_template_marketplaces",
          "searchable": true
        },
        "type": "object",
        "properties": {
          "id": {
            "x-rhino-attribute": {
              "name": "id",
              "readableName": "Id",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "identifier"
          },
          "marketplace": {
            "x-rhino-attribute": {
              "name": "marketplace",
              "readableName": "Marketplace",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": false,
            "type": "boolean"
          },
          "name": {
            "x-rhino-attribute": {
              "name": "name",
              "readableName": "Name",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "type": "string"
          },
          "icon": {
            "x-rhino-attribute": {
              "name": "icon",
              "readableName": "Icon",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "type": "string"
          },
          "description": {
            "x-rhino-attribute": {
              "name": "description",
              "readableName": "Description",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "type": "text"
          },
          "slug": {
            "x-rhino-attribute": {
              "name": "slug",
              "readableName": "Slug",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "type": "string"
          },
          "product": {
            "x-rhino-attribute": {
              "name": "product",
              "readableName": "Product",
              "readable": false,
              "creatable": true,
              "updatable": true
            },
            "writeOnly": true,
            "nullable": false,
            "type": "jsonb"
          },
          "discarded_at": {
            "x-rhino-attribute": {
              "name": "discarded_at",
              "readableName": "Discarded At",
              "readable": false,
              "creatable": true,
              "updatable": true
            },
            "writeOnly": true,
            "nullable": true,
            "type": "string",
            "format": "datetime"
          },
          "organization": {
            "x-rhino-attribute": {
              "name": "organization",
              "readableName": "Organization",
              "readable": false,
              "creatable": true,
              "updatable": true
            },
            "writeOnly": true,
            "nullable": true,
            "type": "reference",
            "anyOf": [
              {
                "$ref": "#/components/schemas/organization"
              }
            ]
          }
        },
        "required": [
          "marketplace",
          "name",
          "icon",
          "description",
          "slug",
          "product"
        ]
      },
      "question": {
        "x-rhino-model": {
          "model": "question",
          "modelPlural": "questions",
          "name": "question",
          "pluralName": "questions",
          "readableName": "Question",
          "pluralReadableName": "Questions",
          "ownedBy": "product",
          "singular": false,
          "path": "/api/questions",
          "searchable": false
        },
        "type": "object",
        "properties": {
          "id": {
            "x-rhino-attribute": {
              "name": "id",
              "readableName": "Id",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "identifier"
          },
          "agent": {
            "x-rhino-attribute": {
              "name": "agent",
              "readableName": "Agent",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "string"
          },
          "question": {
            "x-rhino-attribute": {
              "name": "question",
              "readableName": "Question",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "string"
          },
          "discarded_at": {
            "x-rhino-attribute": {
              "name": "discarded_at",
              "readableName": "Discarded At",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "string",
            "format": "datetime"
          },
          "created_at": {
            "x-rhino-attribute": {
              "name": "created_at",
              "readableName": "Created At",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "string",
            "format": "datetime"
          },
          "updated_at": {
            "x-rhino-attribute": {
              "name": "updated_at",
              "readableName": "Updated At",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "string",
            "format": "datetime"
          },
          "tags": {
            "x-rhino-attribute": {
              "name": "tags",
              "readableName": "Tags",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "default": [

            ],
            "type": "array",
            "items": {
              "type": "string"
            }
          },
          "suggestions": {
            "x-rhino-attribute": {
              "name": "suggestions",
              "readableName": "Suggestions",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "default": [

            ],
            "type": "array",
            "items": {
              "type": "string"
            }
          },
          "suggestions_multi_select": {
            "x-rhino-attribute": {
              "name": "suggestions_multi_select",
              "readableName": "Suggestions Multi Select",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": true,
            "type": "boolean"
          },
          "product": {
            "x-rhino-attribute": {
              "name": "product",
              "readableName": "Product",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "type": "reference",
            "anyOf": [
              {
                "$ref": "#/components/schemas/product"
              }
            ]
          }
        },
        "required": [
          "suggestions_multi_select",
          "product"
        ]
      },
      "credit_transaction": {
        "x-rhino-model": {
          "model": "credit_transaction",
          "modelPlural": "credit_transactions",
          "name": "creditTransaction",
          "pluralName": "creditTransactions",
          "readableName": "Credit transaction",
          "pluralReadableName": "Credit transactions",
          "ownedBy": "organization",
          "singular": false,
          "path": "/api/credit_transactions",
          "searchable": false
        },
        "type": "object",
        "properties": {
          "id": {
            "x-rhino-attribute": {
              "name": "id",
              "readableName": "Id",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "identifier"
          },
          "amount": {
            "x-rhino-attribute": {
              "name": "amount",
              "readableName": "Amount",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "type": "integer"
          },
          "transaction_type": {
            "x-rhino-attribute": {
              "name": "transaction_type",
              "readableName": "Transaction Type",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "type": "string",
            "enum": [
              "refill",
              "bonus",
              "consumption",
              "expiration",
              "refund",
              "topup"
            ]
          },
          "metadata": {
            "x-rhino-attribute": {
              "name": "metadata",
              "readableName": "Metadata",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "default": {
            },
            "type": "jsonb"
          },
          "created_at": {
            "x-rhino-attribute": {
              "name": "created_at",
              "readableName": "Created At",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "string",
            "format": "datetime"
          },
          "updated_at": {
            "x-rhino-attribute": {
              "name": "updated_at",
              "readableName": "Updated At",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "string",
            "format": "datetime"
          },
          "organization": {
            "x-rhino-attribute": {
              "name": "organization",
              "readableName": "Organization",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "type": "reference",
            "anyOf": [
              {
                "$ref": "#/components/schemas/organization"
              }
            ]
          }
        },
        "required": [
          "amount",
          "transaction_type",
          "organization"
        ]
      },
      "pipeline_run": {
        "x-rhino-model": {
          "model": "pipeline_run",
          "modelPlural": "pipeline_runs",
          "name": "pipelineRun",
          "pluralName": "pipelineRuns",
          "readableName": "Pipeline run",
          "pluralReadableName": "Pipeline runs",
          "ownedBy": "product",
          "singular": false,
          "path": "/api/pipeline_runs",
          "searchable": false
        },
        "type": "object",
        "properties": {
          "id": {
            "x-rhino-attribute": {
              "name": "id",
              "readableName": "Id",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "identifier"
          },
          "status": {
            "x-rhino-attribute": {
              "name": "status",
              "readableName": "Status",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": "pending",
            "type": "string",
            "enum": [
              "pending",
              "busy",
              "completed",
              "failed",
              "paused"
            ]
          },
          "current_stage": {
            "x-rhino-attribute": {
              "name": "current_stage",
              "readableName": "Current Stage",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "string"
          },
          "stage_status": {
            "x-rhino-attribute": {
              "name": "stage_status",
              "readableName": "Stage Status",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "default": "pending",
            "type": "string",
            "enum": [
              "pending",
              "running",
              "completed",
              "failed",
              "skipped"
            ]
          },
          "stage_message": {
            "x-rhino-attribute": {
              "name": "stage_message",
              "readableName": "Stage Message",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "text"
          },
          "stages_completed": {
            "x-rhino-attribute": {
              "name": "stages_completed",
              "readableName": "Stages Completed",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": 0,
            "type": "integer",
            "minimum": 0
          },
          "total_stages": {
            "x-rhino-attribute": {
              "name": "total_stages",
              "readableName": "Total Stages",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "integer",
            "minimum": 0,
            "exclusiveMinimum": true
          },
          "error_message": {
            "x-rhino-attribute": {
              "name": "error_message",
              "readableName": "Error Message",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "text"
          },
          "started_at": {
            "x-rhino-attribute": {
              "name": "started_at",
              "readableName": "Started At",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "string",
            "format": "datetime"
          },
          "completed_at": {
            "x-rhino-attribute": {
              "name": "completed_at",
              "readableName": "Completed At",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "string",
            "format": "datetime"
          },
          "created_at": {
            "x-rhino-attribute": {
              "name": "created_at",
              "readableName": "Created At",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "string",
            "format": "datetime"
          },
          "updated_at": {
            "x-rhino-attribute": {
              "name": "updated_at",
              "readableName": "Updated At",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "string",
            "format": "datetime"
          },
          "repo_url": {
            "x-rhino-attribute": {
              "name": "repo_url",
              "readableName": "Repo Url",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "string"
          },
          "repo_branch": {
            "x-rhino-attribute": {
              "name": "repo_branch",
              "readableName": "Repo Branch",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "string"
          },
          "trigger_source": {
            "x-rhino-attribute": {
              "name": "trigger_source",
              "readableName": "Trigger Source",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "string"
          },
          "paused_reason": {
            "x-rhino-attribute": {
              "name": "paused_reason",
              "readableName": "Paused Reason",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "string"
          },
          "callback_token": {
            "x-rhino-attribute": {
              "name": "callback_token",
              "readableName": "Callback Token",
              "readable": false,
              "creatable": true,
              "updatable": true
            },
            "writeOnly": true,
            "nullable": false,
            "type": "string"
          },
          "stage_outputs": {
            "x-rhino-attribute": {
              "name": "stage_outputs",
              "readableName": "Stage Outputs",
              "readable": false,
              "creatable": true,
              "updatable": true
            },
            "writeOnly": true,
            "nullable": false,
            "default": {
            },
            "type": "jsonb"
          },
          "analysis_attempt": {
            "x-rhino-attribute": {
              "name": "analysis_attempt",
              "readableName": "Analysis Attempt",
              "readable": false,
              "creatable": true,
              "updatable": true
            },
            "writeOnly": true,
            "nullable": false,
            "default": 0,
            "type": "integer"
          },
          "source_integrity_report": {
            "x-rhino-attribute": {
              "name": "source_integrity_report",
              "readableName": "Source Integrity Report",
              "readable": false,
              "creatable": true,
              "updatable": true
            },
            "writeOnly": true,
            "nullable": false,
            "default": {
            },
            "type": "jsonb"
          },
          "product": {
            "x-rhino-attribute": {
              "name": "product",
              "readableName": "Product",
              "readable": false,
              "creatable": true,
              "updatable": true
            },
            "writeOnly": true,
            "nullable": false,
            "type": "reference",
            "anyOf": [
              {
                "$ref": "#/components/schemas/product"
              }
            ]
          }
        },
        "required": [
          "status",
          "stages_completed",
          "callback_token",
          "stage_outputs",
          "analysis_attempt",
          "source_integrity_report",
          "product"
        ]
      },
      "llm_usage_record": {
        "x-rhino-model": {
          "model": "llm_usage_record",
          "modelPlural": "llm_usage_records",
          "name": "llmUsageRecord",
          "pluralName": "llmUsageRecords",
          "readableName": "Llm usage record",
          "pluralReadableName": "Llm usage records",
          "ownedBy": "organization",
          "singular": false,
          "path": "/api/llm_usage_records",
          "searchable": false
        },
        "type": "object",
        "properties": {
          "id": {
            "x-rhino-attribute": {
              "name": "id",
              "readableName": "Id",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "identifier"
          },
          "organization_id": {
            "x-rhino-attribute": {
              "name": "organization_id",
              "readableName": "Organization",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "integer"
          },
          "product_id": {
            "x-rhino-attribute": {
              "name": "product_id",
              "readableName": "Product",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": true,
            "type": "integer"
          },
          "product_name": {
            "x-rhino-attribute": {
              "name": "product_name",
              "readableName": "Product Name",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": true,
            "type": "unknown"
          },
          "prd_id": {
            "x-rhino-attribute": {
              "name": "prd_id",
              "readableName": "Prd",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": true,
            "type": "integer"
          },
          "user_id": {
            "x-rhino-attribute": {
              "name": "user_id",
              "readableName": "User",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": true,
            "type": "integer"
          },
          "pipeline_run_id": {
            "x-rhino-attribute": {
              "name": "pipeline_run_id",
              "readableName": "Pipeline Run",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": true,
            "type": "uuid"
          },
          "source": {
            "x-rhino-attribute": {
              "name": "source",
              "readableName": "Source",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "type": "string",
            "enum": [
              "langchain_orchestrator",
              "keystone",
              "openhands"
            ]
          },
          "flow_type": {
            "x-rhino-attribute": {
              "name": "flow_type",
              "readableName": "Flow Type",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "type": "string",
            "enum": [
              "generate_prd",
              "generate_prd_v2",
              "edit_prd",
              "ui_prototype",
              "quick_ui",
              "post_processing",
              "code_generation",
              "repo_analysis",
              "prd_change_proposal",
              "ui_prototype_prd_sync"
            ]
          },
          "input_tokens": {
            "x-rhino-attribute": {
              "name": "input_tokens",
              "readableName": "Input Tokens",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": 0,
            "type": "integer",
            "minimum": 0
          },
          "output_tokens": {
            "x-rhino-attribute": {
              "name": "output_tokens",
              "readableName": "Output Tokens",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": 0,
            "type": "integer",
            "minimum": 0
          },
          "total_tokens": {
            "x-rhino-attribute": {
              "name": "total_tokens",
              "readableName": "Total Tokens",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": 0,
            "type": "integer",
            "minimum": 0
          },
          "cost_usd": {
            "x-rhino-attribute": {
              "name": "cost_usd",
              "readableName": "Cost Usd",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": "0.0",
            "type": "decimal",
            "minimum": 0
          },
          "model_breakdown": {
            "x-rhino-attribute": {
              "name": "model_breakdown",
              "readableName": "Model Breakdown",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": {
            },
            "type": "jsonb"
          },
          "agent_breakdown": {
            "x-rhino-attribute": {
              "name": "agent_breakdown",
              "readableName": "Agent Breakdown",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": {
            },
            "type": "jsonb"
          },
          "langsmith_run_id": {
            "x-rhino-attribute": {
              "name": "langsmith_run_id",
              "readableName": "Langsmith Run",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "string"
          },
          "metadata": {
            "x-rhino-attribute": {
              "name": "metadata",
              "readableName": "Metadata",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": {
            },
            "type": "jsonb"
          },
          "created_at": {
            "x-rhino-attribute": {
              "name": "created_at",
              "readableName": "Created At",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "string",
            "format": "datetime"
          },
          "updated_at": {
            "x-rhino-attribute": {
              "name": "updated_at",
              "readableName": "Updated At",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "string",
            "format": "datetime"
          },
          "raw_provider_cost_usd": {
            "x-rhino-attribute": {
              "name": "raw_provider_cost_usd",
              "readableName": "Raw Provider Cost Usd",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": true,
            "type": "unknown"
          },
          "billable_cost_usd": {
            "x-rhino-attribute": {
              "name": "billable_cost_usd",
              "readableName": "Billable Cost Usd",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": true,
            "type": "unknown"
          },
          "margin_rate": {
            "x-rhino-attribute": {
              "name": "margin_rate",
              "readableName": "Margin Rate",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": true,
            "type": "unknown"
          },
          "margin_category": {
            "x-rhino-attribute": {
              "name": "margin_category",
              "readableName": "Margin Category",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": true,
            "type": "unknown"
          },
          "codalio_tokens": {
            "x-rhino-attribute": {
              "name": "codalio_tokens",
              "readableName": "Codalio Tokens",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": true,
            "type": "unknown"
          },
          "billable_credits": {
            "x-rhino-attribute": {
              "name": "billable_credits",
              "readableName": "Billable Credits",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": true,
            "type": "unknown"
          },
          "credits_charged": {
            "x-rhino-attribute": {
              "name": "credits_charged",
              "readableName": "Credits Charged",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": true,
            "type": "unknown"
          },
          "codalio_token_formula_metadata": {
            "x-rhino-attribute": {
              "name": "codalio_token_formula_metadata",
              "readableName": "Codalio Token Formula Metadata",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": true,
            "type": "unknown"
          },
          "flow_group_key": {
            "x-rhino-attribute": {
              "name": "flow_group_key",
              "readableName": "Flow Group Key",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": true,
            "type": "unknown"
          },
          "flow_group_label": {
            "x-rhino-attribute": {
              "name": "flow_group_label",
              "readableName": "Flow Group Label",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": true,
            "type": "unknown"
          },
          "organization": {
            "x-rhino-attribute": {
              "name": "organization",
              "readableName": "Organization",
              "readable": false,
              "creatable": true,
              "updatable": true
            },
            "writeOnly": true,
            "nullable": false,
            "type": "reference",
            "anyOf": [
              {
                "$ref": "#/components/schemas/organization"
              }
            ]
          },
          "product": {
            "x-rhino-attribute": {
              "name": "product",
              "readableName": "Product",
              "readable": false,
              "creatable": true,
              "updatable": true
            },
            "writeOnly": true,
            "nullable": true,
            "type": "reference",
            "anyOf": [
              {
                "$ref": "#/components/schemas/product"
              }
            ]
          },
          "prd": {
            "x-rhino-attribute": {
              "name": "prd",
              "readableName": "Prd",
              "readable": false,
              "creatable": true,
              "updatable": true
            },
            "writeOnly": true,
            "nullable": true,
            "type": "reference",
            "anyOf": [
              {
                "$ref": "#/components/schemas/prd"
              }
            ]
          },
          "user": {
            "x-rhino-attribute": {
              "name": "user",
              "readableName": "User",
              "readable": false,
              "creatable": true,
              "updatable": true
            },
            "writeOnly": true,
            "nullable": true,
            "type": "reference",
            "anyOf": [
              {
                "$ref": "#/components/schemas/user"
              }
            ]
          },
          "pipeline_run": {
            "x-rhino-attribute": {
              "name": "pipeline_run",
              "readableName": "Pipeline Run",
              "readable": false,
              "creatable": true,
              "updatable": true
            },
            "writeOnly": true,
            "nullable": true,
            "type": "reference",
            "anyOf": [
              {
                "$ref": "#/components/schemas/pipeline_run"
              }
            ]
          }
        },
        "required": [
          "source",
          "flow_type",
          "input_tokens",
          "output_tokens",
          "total_tokens",
          "cost_usd",
          "model_breakdown",
          "agent_breakdown",
          "metadata",
          "organization"
        ]
      },
      "queued_chat_message": {
        "x-rhino-model": {
          "model": "queued_chat_message",
          "modelPlural": "queued_chat_messages",
          "name": "queuedChatMessage",
          "pluralName": "queuedChatMessages",
          "readableName": "Queued chat message",
          "pluralReadableName": "Queued chat messages",
          "ownedBy": "product",
          "singular": false,
          "path": "/api/queued_chat_messages",
          "searchable": false
        },
        "type": "object",
        "properties": {
          "id": {
            "x-rhino-attribute": {
              "name": "id",
              "readableName": "Id",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "identifier"
          },
          "surface": {
            "x-rhino-attribute": {
              "name": "surface",
              "readableName": "Surface",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": "prd_interview",
            "type": "string",
            "enum": [
              "prd_interview",
              "ui_prototype",
              "code_generation"
            ]
          },
          "status": {
            "x-rhino-attribute": {
              "name": "status",
              "readableName": "Status",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "default": "queued",
            "type": "string",
            "enum": [
              "queued",
              "paused",
              "dispatching",
              "failed"
            ]
          },
          "content": {
            "x-rhino-attribute": {
              "name": "content",
              "readableName": "Content",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": "",
            "type": "text"
          },
          "error_code": {
            "x-rhino-attribute": {
              "name": "error_code",
              "readableName": "Error Code",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": true,
            "type": "string"
          },
          "error_message": {
            "x-rhino-attribute": {
              "name": "error_message",
              "readableName": "Error Message",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": true,
            "type": "text"
          },
          "created_at": {
            "x-rhino-attribute": {
              "name": "created_at",
              "readableName": "Created At",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "string",
            "format": "datetime"
          },
          "updated_at": {
            "x-rhino-attribute": {
              "name": "updated_at",
              "readableName": "Updated At",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "string",
            "format": "datetime"
          }
        },
        "required": [
          "surface",
          "content"
        ]
      },
      "llm_model": {
        "x-rhino-model": {
          "model": "llm_model",
          "modelPlural": "llm_models",
          "name": "llmModel",
          "pluralName": "llmModels",
          "readableName": "Llm model",
          "pluralReadableName": "Llm models",
          "ownedBy": "global",
          "singular": false,
          "path": "/api/llm_models",
          "searchable": false
        },
        "type": "object",
        "properties": {
          "id": {
            "x-rhino-attribute": {
              "name": "id",
              "readableName": "Id",
              "readable": true,
              "creatable": false,
              "updatable": false
            },
            "readOnly": true,
            "nullable": false,
            "type": "identifier"
          },
          "spec": {
            "x-rhino-attribute": {
              "name": "spec",
              "readableName": "Spec",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "type": "string",
            "pattern": "^[a-z0-9_]+\\/\\S+$"
          },
          "label": {
            "x-rhino-attribute": {
              "name": "label",
              "readableName": "Label",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "string"
          },
          "picker_hint": {
            "x-rhino-attribute": {
              "name": "picker_hint",
              "readableName": "Picker Hint",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "type": "string",
            "maxLength": 40
          },
          "display_order": {
            "x-rhino-attribute": {
              "name": "display_order",
              "readableName": "Display Order",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": false,
            "default": 0,
            "type": "integer"
          },
          "agent_default": {
            "x-rhino-attribute": {
              "name": "agent_default",
              "readableName": "Agent Default",
              "readable": true,
              "creatable": true,
              "updatable": true
            },
            "nullable": true,
            "default": false,
            "type": "boolean"
          },
          "flows": {
            "x-rhino-attribute": {
              "name": "flows",
              "readableName": "Flows",
              "readable": false,
              "creatable": true,
              "updatable": true
            },
            "writeOnly": true,
            "nullable": false,
            "default": [

            ],
            "type": "array",
            "items": {
              "type": "string"
            }
          },
          "enabled": {
            "x-rhino-attribute": {
              "name": "enabled",
              "readableName": "Enabled",
              "readable": false,
              "creatable": true,
              "updatable": true
            },
            "writeOnly": true,
            "nullable": false,
            "default": true,
            "type": "boolean"
          },
          "notes": {
            "x-rhino-attribute": {
              "name": "notes",
              "readableName": "Notes",
              "readable": false,
              "creatable": true,
              "updatable": true
            },
            "writeOnly": true,
            "nullable": true,
            "type": "text"
          },
          "user_selectable": {
            "x-rhino-attribute": {
              "name": "user_selectable",
              "readableName": "User Selectable",
              "readable": false,
              "creatable": true,
              "updatable": true
            },
            "writeOnly": true,
            "nullable": false,
            "default": false,
            "type": "boolean"
          },
          "stage_models": {
            "x-rhino-attribute": {
              "name": "stage_models",
              "readableName": "Stage Models",
              "readable": false,
              "creatable": true,
              "updatable": true
            },
            "writeOnly": true,
            "nullable": false,
            "default": {
            },
            "type": "jsonb"
          }
        },
        "required": [
          "spec",
          "display_order",
          "flows",
          "enabled",
          "user_selectable",
          "stage_models"
        ]
      }
    }
  },
  "paths": {
    "/api/organizations/:id/github/integrations(.:format)": {
      "get": {
        "operationId": "organization-integrations",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/organization"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "organization"
        ]
      }
    },
    "/api/organizations/:id/github/repositories(.:format)": {
      "get": {
        "operationId": "organization-repositories",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/organization"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "organization"
        ]
      }
    },
    "/api/organizations/:id/github/install(.:format)": {
      "get": {
        "operationId": "organization-install",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/organization"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "organization"
        ]
      }
    },
    "/api/organizations/:id/github/disconnect(.:format)": {
      "delete": {
        "operationId": "organization-disconnect",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/organization"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "organization"
        ]
      }
    },
    "/api/organizations/:id/aws/onboard(.:format)": {
      "post": {
        "operationId": "organization-create",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/organization"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "organization"
        ]
      }
    },
    "/api/organizations/:id/aws/check_permissions(.:format)": {
      "post": {
        "operationId": "organization-check_permissions",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/organization"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "organization"
        ]
      }
    },
    "/api/products/:id/improve": {
      "post": {
        "operationId": "product-create",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/product"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "product"
        ]
      }
    },
    "/api/products/:id/push_to_github": {
      "patch": {
        "operationId": "product-update",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/product"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "product"
        ]
      }
    },
    "/api/products/:id/prd_approvals": {
      "patch": {
        "operationId": "product-update",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/product"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "product"
        ]
      }
    },
    "/api/products/:id/design_spec": {
      "patch": {
        "operationId": "product-update",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/product"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "product"
        ]
      }
    },
    "/api/products/:id/prd_sections": {
      "patch": {
        "operationId": "product-update",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/product"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "product"
        ]
      }
    },
    "/api/products/:id/onboarding_completion": {
      "patch": {
        "operationId": "product-update",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/product"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "product"
        ]
      }
    },
    "/api/products/:id/design_preferences": {
      "patch": {
        "operationId": "product-update",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/product"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "product"
        ]
      }
    },
    "/api/products/:id/product_export(.:format)": {
      "get": {
        "operationId": "product-show",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/product"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "product"
        ]
      }
    },
    "/api/products/:id/product_documents/:document_id/rendition": {
      "get": {
        "operationId": "product-show",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          },
          {
            "name": "document_id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/product"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "product"
        ]
      }
    },
    "/api/products/:id/generate_template": {
      "post": {
        "operationId": "product-create",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/product"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "product"
        ]
      }
    },
    "/api/products/:id/trigger_estimation": {
      "post": {
        "operationId": "product-create",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/product"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "product"
        ]
      }
    },
    "/api/repositories/:id/invite": {
      "post": {
        "operationId": "repository-create",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/repository"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "repository"
        ]
      }
    },
    "/api/repositories/:id/live_dev_launch": {
      "post": {
        "operationId": "repository-create",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/repository"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "repository"
        ]
      },
      "patch": {
        "operationId": "repository-update",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/repository"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "repository"
        ]
      },
      "delete": {
        "operationId": "repository-destroy",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/repository"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "repository"
        ]
      }
    },
    "/api/plannings/:id/next": {
      "patch": {
        "operationId": "planning-update",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/planning"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "planning"
        ]
      }
    },
    "/api/live_devs/:id/ping": {
      "get": {
        "operationId": "live_dev-show",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/live_dev"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "live_dev"
        ]
      }
    },
    "/api/live_devs/:id/chat": {
      "patch": {
        "operationId": "live_dev-update",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/live_dev"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "live_dev"
        ]
      }
    },
    "/api/live_devs/:id/commit": {
      "patch": {
        "operationId": "live_dev-update",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/live_dev"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "live_dev"
        ]
      }
    },
    "/api/live_devs/:id/rollback": {
      "patch": {
        "operationId": "live_dev-update",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/live_dev"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "live_dev"
        ]
      }
    },
    "/api/attachments": {
      "get": {
        "operationId": "active_storage_attachment-index",
        "parameters": [

        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/active_storage_attachment"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "active_storage_attachment"
        ]
      },
      "post": {
        "operationId": "active_storage_attachment-create",
        "parameters": [

        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/active_storage_attachment"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "active_storage_attachment"
        ]
      }
    },
    "/api/attachments/:id": {
      "get": {
        "operationId": "active_storage_attachment-show",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/active_storage_attachment"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "active_storage_attachment"
        ]
      },
      "patch": {
        "operationId": "active_storage_attachment-update",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/active_storage_attachment"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "active_storage_attachment"
        ]
      },
      "put": {
        "operationId": "active_storage_attachment-update",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/active_storage_attachment"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "active_storage_attachment"
        ]
      },
      "delete": {
        "operationId": "active_storage_attachment-destroy",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/active_storage_attachment"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "active_storage_attachment"
        ]
      }
    },
    "/api/users": {
      "get": {
        "operationId": "user-index",
        "parameters": [

        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/user"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "user"
        ]
      },
      "post": {
        "operationId": "user-create",
        "parameters": [

        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/user"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "user"
        ]
      }
    },
    "/api/users/:id": {
      "get": {
        "operationId": "user-show",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/user"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "user"
        ]
      },
      "patch": {
        "operationId": "user-update",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/user"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "user"
        ]
      },
      "put": {
        "operationId": "user-update",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/user"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "user"
        ]
      },
      "delete": {
        "operationId": "user-destroy",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/user"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "user"
        ]
      }
    },
    "/api/account": {
      "get": {
        "operationId": "account-show",
        "parameters": [

        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/account"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "account"
        ]
      },
      "patch": {
        "operationId": "account-update",
        "parameters": [

        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/account"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "account"
        ]
      },
      "put": {
        "operationId": "account-update",
        "parameters": [

        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/account"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "account"
        ]
      }
    },
    "/api/organizations": {
      "get": {
        "operationId": "organization-index",
        "parameters": [

        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/organization"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "organization"
        ]
      },
      "post": {
        "operationId": "organization-create",
        "parameters": [

        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/organization"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "organization"
        ]
      }
    },
    "/api/organizations/:id": {
      "get": {
        "operationId": "organization-show",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/organization"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "organization"
        ]
      },
      "patch": {
        "operationId": "organization-update",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/organization"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "organization"
        ]
      },
      "put": {
        "operationId": "organization-update",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/organization"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "organization"
        ]
      },
      "delete": {
        "operationId": "organization-destroy",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/organization"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "organization"
        ]
      }
    },
    "/api/users_roles": {
      "get": {
        "operationId": "users_role-index",
        "parameters": [

        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/users_role"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "users_role"
        ]
      },
      "post": {
        "operationId": "users_role-create",
        "parameters": [

        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/users_role"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "users_role"
        ]
      }
    },
    "/api/users_roles/:id": {
      "get": {
        "operationId": "users_role-show",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/users_role"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "users_role"
        ]
      },
      "patch": {
        "operationId": "users_role-update",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/users_role"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "users_role"
        ]
      },
      "put": {
        "operationId": "users_role-update",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/users_role"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "users_role"
        ]
      },
      "delete": {
        "operationId": "users_role-destroy",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/users_role"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "users_role"
        ]
      }
    },
    "/api/roles": {
      "get": {
        "operationId": "role-index",
        "parameters": [

        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/role"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "role"
        ]
      }
    },
    "/api/roles/:id": {
      "get": {
        "operationId": "role-show",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/role"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "role"
        ]
      }
    },
    "/api/users_role_invites": {
      "get": {
        "operationId": "users_role_invite-index",
        "parameters": [

        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/users_role_invite"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "users_role_invite"
        ]
      },
      "post": {
        "operationId": "users_role_invite-create",
        "parameters": [

        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/users_role_invite"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "users_role_invite"
        ]
      }
    },
    "/api/users_role_invites/:id": {
      "get": {
        "operationId": "users_role_invite-show",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/users_role_invite"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "users_role_invite"
        ]
      },
      "patch": {
        "operationId": "users_role_invite-update",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/users_role_invite"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "users_role_invite"
        ]
      },
      "put": {
        "operationId": "users_role_invite-update",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/users_role_invite"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "users_role_invite"
        ]
      },
      "delete": {
        "operationId": "users_role_invite-destroy",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/users_role_invite"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "users_role_invite"
        ]
      }
    },
    "/api/live_devs": {
      "get": {
        "operationId": "live_dev-index",
        "parameters": [

        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/live_dev"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "live_dev"
        ]
      }
    },
    "/api/live_devs/:id": {
      "get": {
        "operationId": "live_dev-show",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/live_dev"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "live_dev"
        ]
      }
    },
    "/api/plannings": {
      "get": {
        "operationId": "planning-index",
        "parameters": [

        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/planning"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "planning"
        ]
      },
      "post": {
        "operationId": "planning-create",
        "parameters": [

        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/planning"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "planning"
        ]
      }
    },
    "/api/plannings/:id": {
      "get": {
        "operationId": "planning-show",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/planning"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "planning"
        ]
      },
      "patch": {
        "operationId": "planning-update",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/planning"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "planning"
        ]
      },
      "put": {
        "operationId": "planning-update",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/planning"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "planning"
        ]
      },
      "delete": {
        "operationId": "planning-destroy",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/planning"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "planning"
        ]
      }
    },
    "/api/plugins": {
      "get": {
        "operationId": "plugin-index",
        "parameters": [

        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/plugin"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "plugin"
        ]
      }
    },
    "/api/plugins/:id": {
      "get": {
        "operationId": "plugin-show",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/plugin"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "plugin"
        ]
      }
    },
    "/api/products": {
      "get": {
        "operationId": "product-index",
        "parameters": [

        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/product"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "product"
        ]
      },
      "post": {
        "operationId": "product-create",
        "parameters": [

        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/product"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "product"
        ]
      }
    },
    "/api/products/:id": {
      "get": {
        "operationId": "product-show",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/product"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "product"
        ]
      },
      "patch": {
        "operationId": "product-update",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/product"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "product"
        ]
      },
      "put": {
        "operationId": "product-update",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/product"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "product"
        ]
      },
      "delete": {
        "operationId": "product-destroy",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/product"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "product"
        ]
      }
    },
    "/api/products_plugins": {
      "get": {
        "operationId": "products_plugin-index",
        "parameters": [

        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/products_plugin"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "products_plugin"
        ]
      },
      "post": {
        "operationId": "products_plugin-create",
        "parameters": [

        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/products_plugin"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "products_plugin"
        ]
      }
    },
    "/api/products_plugins/:id": {
      "get": {
        "operationId": "products_plugin-show",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/products_plugin"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "products_plugin"
        ]
      },
      "patch": {
        "operationId": "products_plugin-update",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/products_plugin"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "products_plugin"
        ]
      },
      "put": {
        "operationId": "products_plugin-update",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/products_plugin"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "products_plugin"
        ]
      },
      "delete": {
        "operationId": "products_plugin-destroy",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/products_plugin"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "products_plugin"
        ]
      }
    },
    "/api/products_variables": {
      "get": {
        "operationId": "products_variable-index",
        "parameters": [

        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/products_variable"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "products_variable"
        ]
      },
      "post": {
        "operationId": "products_variable-create",
        "parameters": [

        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/products_variable"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "products_variable"
        ]
      }
    },
    "/api/products_variables/:id": {
      "get": {
        "operationId": "products_variable-show",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/products_variable"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "products_variable"
        ]
      },
      "patch": {
        "operationId": "products_variable-update",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/products_variable"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "products_variable"
        ]
      },
      "put": {
        "operationId": "products_variable-update",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/products_variable"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "products_variable"
        ]
      },
      "delete": {
        "operationId": "products_variable-destroy",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/products_variable"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "products_variable"
        ]
      }
    },
    "/api/prds": {
      "get": {
        "operationId": "prd-index",
        "parameters": [

        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/prd"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "prd"
        ]
      },
      "post": {
        "operationId": "prd-create",
        "parameters": [

        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/prd"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "prd"
        ]
      }
    },
    "/api/prds/:id": {
      "get": {
        "operationId": "prd-show",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/prd"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "prd"
        ]
      },
      "patch": {
        "operationId": "prd-update",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/prd"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "prd"
        ]
      },
      "put": {
        "operationId": "prd-update",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/prd"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "prd"
        ]
      },
      "delete": {
        "operationId": "prd-destroy",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/prd"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "prd"
        ]
      }
    },
    "/api/repositories": {
      "get": {
        "operationId": "repository-index",
        "parameters": [

        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/repository"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "repository"
        ]
      },
      "post": {
        "operationId": "repository-create",
        "parameters": [

        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/repository"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "repository"
        ]
      }
    },
    "/api/repositories/:id": {
      "get": {
        "operationId": "repository-show",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/repository"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "repository"
        ]
      },
      "patch": {
        "operationId": "repository-update",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/repository"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "repository"
        ]
      },
      "put": {
        "operationId": "repository-update",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/repository"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "repository"
        ]
      },
      "delete": {
        "operationId": "repository-destroy",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/repository"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "repository"
        ]
      }
    },
    "/api/variables": {
      "get": {
        "operationId": "variable-index",
        "parameters": [

        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/variable"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "variable"
        ]
      },
      "post": {
        "operationId": "variable-create",
        "parameters": [

        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/variable"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "variable"
        ]
      }
    },
    "/api/variables/:id": {
      "get": {
        "operationId": "variable-show",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/variable"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "variable"
        ]
      },
      "patch": {
        "operationId": "variable-update",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/variable"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "variable"
        ]
      },
      "put": {
        "operationId": "variable-update",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/variable"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "variable"
        ]
      },
      "delete": {
        "operationId": "variable-destroy",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/variable"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "variable"
        ]
      }
    },
    "/api/deployments": {
      "get": {
        "operationId": "deployment-index",
        "parameters": [

        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/deployment"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "deployment"
        ]
      },
      "post": {
        "operationId": "deployment-create",
        "parameters": [

        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/deployment"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "deployment"
        ]
      }
    },
    "/api/deployments/:id": {
      "get": {
        "operationId": "deployment-show",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/deployment"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "deployment"
        ]
      },
      "patch": {
        "operationId": "deployment-update",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/deployment"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "deployment"
        ]
      },
      "put": {
        "operationId": "deployment-update",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/deployment"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "deployment"
        ]
      },
      "delete": {
        "operationId": "deployment-destroy",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/deployment"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "deployment"
        ]
      }
    },
    "/api/google_cloud_regions": {
      "get": {
        "operationId": "google_cloud_region-index",
        "parameters": [

        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/google_cloud_region"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "google_cloud_region"
        ]
      }
    },
    "/api/google_cloud_regions/:id": {
      "get": {
        "operationId": "google_cloud_region-show",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/google_cloud_region"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "google_cloud_region"
        ]
      }
    },
    "/api/google_cloud_deployments": {
      "get": {
        "operationId": "google_cloud_deployment-index",
        "parameters": [

        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/google_cloud_deployment"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "google_cloud_deployment"
        ]
      },
      "post": {
        "operationId": "google_cloud_deployment-create",
        "parameters": [

        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/google_cloud_deployment"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "google_cloud_deployment"
        ]
      }
    },
    "/api/google_cloud_deployments/:id": {
      "get": {
        "operationId": "google_cloud_deployment-show",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/google_cloud_deployment"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "google_cloud_deployment"
        ]
      },
      "patch": {
        "operationId": "google_cloud_deployment-update",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/google_cloud_deployment"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "google_cloud_deployment"
        ]
      },
      "put": {
        "operationId": "google_cloud_deployment-update",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/google_cloud_deployment"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "google_cloud_deployment"
        ]
      },
      "delete": {
        "operationId": "google_cloud_deployment-destroy",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/google_cloud_deployment"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "google_cloud_deployment"
        ]
      }
    },
    "/api/heroku_deployments": {
      "get": {
        "operationId": "heroku_deployment-index",
        "parameters": [

        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/heroku_deployment"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "heroku_deployment"
        ]
      },
      "post": {
        "operationId": "heroku_deployment-create",
        "parameters": [

        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/heroku_deployment"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "heroku_deployment"
        ]
      }
    },
    "/api/heroku_deployments/:id": {
      "get": {
        "operationId": "heroku_deployment-show",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/heroku_deployment"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "heroku_deployment"
        ]
      },
      "patch": {
        "operationId": "heroku_deployment-update",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/heroku_deployment"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "heroku_deployment"
        ]
      },
      "put": {
        "operationId": "heroku_deployment-update",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/heroku_deployment"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "heroku_deployment"
        ]
      },
      "delete": {
        "operationId": "heroku_deployment-destroy",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/heroku_deployment"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "heroku_deployment"
        ]
      }
    },
    "/api/aws_setups": {
      "get": {
        "operationId": "aws_setup-index",
        "parameters": [

        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/aws_setup"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "aws_setup"
        ]
      },
      "post": {
        "operationId": "aws_setup-create",
        "parameters": [

        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/aws_setup"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "aws_setup"
        ]
      }
    },
    "/api/aws_setups/:id": {
      "get": {
        "operationId": "aws_setup-show",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/aws_setup"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "aws_setup"
        ]
      },
      "patch": {
        "operationId": "aws_setup-update",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/aws_setup"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "aws_setup"
        ]
      },
      "put": {
        "operationId": "aws_setup-update",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/aws_setup"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "aws_setup"
        ]
      },
      "delete": {
        "operationId": "aws_setup-destroy",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/aws_setup"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "aws_setup"
        ]
      }
    },
    "/api/aws_resources": {
      "get": {
        "operationId": "aws_resource-index",
        "parameters": [

        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/aws_resource"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "aws_resource"
        ]
      },
      "post": {
        "operationId": "aws_resource-create",
        "parameters": [

        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/aws_resource"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "aws_resource"
        ]
      }
    },
    "/api/aws_resources/:id": {
      "get": {
        "operationId": "aws_resource-show",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/aws_resource"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "aws_resource"
        ]
      },
      "patch": {
        "operationId": "aws_resource-update",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/aws_resource"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "aws_resource"
        ]
      },
      "put": {
        "operationId": "aws_resource-update",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/aws_resource"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "aws_resource"
        ]
      },
      "delete": {
        "operationId": "aws_resource-destroy",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/aws_resource"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "aws_resource"
        ]
      }
    },
    "/api/aws_deployments": {
      "get": {
        "operationId": "aws_deployment-index",
        "parameters": [

        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/aws_deployment"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "aws_deployment"
        ]
      },
      "post": {
        "operationId": "aws_deployment-create",
        "parameters": [

        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/aws_deployment"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "aws_deployment"
        ]
      }
    },
    "/api/aws_deployments/:id": {
      "get": {
        "operationId": "aws_deployment-show",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/aws_deployment"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "aws_deployment"
        ]
      },
      "patch": {
        "operationId": "aws_deployment-update",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/aws_deployment"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "aws_deployment"
        ]
      },
      "put": {
        "operationId": "aws_deployment-update",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/aws_deployment"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "aws_deployment"
        ]
      },
      "delete": {
        "operationId": "aws_deployment-destroy",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/aws_deployment"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "aws_deployment"
        ]
      }
    },
    "/api/render_deployments": {
      "get": {
        "operationId": "render_deployment-index",
        "parameters": [

        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/render_deployment"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "render_deployment"
        ]
      },
      "post": {
        "operationId": "render_deployment-create",
        "parameters": [

        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/render_deployment"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "render_deployment"
        ]
      }
    },
    "/api/render_deployments/:id": {
      "get": {
        "operationId": "render_deployment-show",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/render_deployment"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "render_deployment"
        ]
      },
      "patch": {
        "operationId": "render_deployment-update",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/render_deployment"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "render_deployment"
        ]
      },
      "put": {
        "operationId": "render_deployment-update",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/render_deployment"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "render_deployment"
        ]
      },
      "delete": {
        "operationId": "render_deployment-destroy",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/render_deployment"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "render_deployment"
        ]
      }
    },
    "/api/ai_models": {
      "get": {
        "operationId": "ai_model-index",
        "parameters": [

        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ai_model"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "ai_model"
        ]
      }
    },
    "/api/ai_models/:id": {
      "get": {
        "operationId": "ai_model-show",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ai_model"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "ai_model"
        ]
      }
    },
    "/api/ai_histories": {
      "get": {
        "operationId": "ai_history-index",
        "parameters": [

        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ai_history"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "ai_history"
        ]
      },
      "post": {
        "operationId": "ai_history-create",
        "parameters": [

        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ai_history"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "ai_history"
        ]
      }
    },
    "/api/ai_histories/:id": {
      "get": {
        "operationId": "ai_history-show",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ai_history"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "ai_history"
        ]
      },
      "patch": {
        "operationId": "ai_history-update",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ai_history"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "ai_history"
        ]
      },
      "put": {
        "operationId": "ai_history-update",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ai_history"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "ai_history"
        ]
      },
      "delete": {
        "operationId": "ai_history-destroy",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ai_history"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "ai_history"
        ]
      }
    },
    "/api/ui_prototypes": {
      "get": {
        "operationId": "ui_prototype-index",
        "parameters": [

        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ui_prototype"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "ui_prototype"
        ]
      },
      "post": {
        "operationId": "ui_prototype-create",
        "parameters": [

        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ui_prototype"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "ui_prototype"
        ]
      }
    },
    "/api/ui_prototypes/:id": {
      "get": {
        "operationId": "ui_prototype-show",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ui_prototype"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "ui_prototype"
        ]
      },
      "patch": {
        "operationId": "ui_prototype-update",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ui_prototype"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "ui_prototype"
        ]
      },
      "put": {
        "operationId": "ui_prototype-update",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ui_prototype"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "ui_prototype"
        ]
      },
      "delete": {
        "operationId": "ui_prototype-destroy",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ui_prototype"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "ui_prototype"
        ]
      }
    },
    "/api/product_roles": {
      "get": {
        "operationId": "product_role-index",
        "parameters": [

        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/product_role"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "product_role"
        ]
      },
      "post": {
        "operationId": "product_role-create",
        "parameters": [

        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/product_role"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "product_role"
        ]
      }
    },
    "/api/product_roles/:id": {
      "get": {
        "operationId": "product_role-show",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/product_role"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "product_role"
        ]
      },
      "patch": {
        "operationId": "product_role-update",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/product_role"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "product_role"
        ]
      },
      "put": {
        "operationId": "product_role-update",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/product_role"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "product_role"
        ]
      },
      "delete": {
        "operationId": "product_role-destroy",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/product_role"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "product_role"
        ]
      }
    },
    "/api/product_stories": {
      "get": {
        "operationId": "product_story-index",
        "parameters": [

        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/product_story"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "product_story"
        ]
      },
      "post": {
        "operationId": "product_story-create",
        "parameters": [

        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/product_story"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "product_story"
        ]
      }
    },
    "/api/product_stories/:id": {
      "get": {
        "operationId": "product_story-show",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/product_story"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "product_story"
        ]
      },
      "patch": {
        "operationId": "product_story-update",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/product_story"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "product_story"
        ]
      },
      "put": {
        "operationId": "product_story-update",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/product_story"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "product_story"
        ]
      },
      "delete": {
        "operationId": "product_story-destroy",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/product_story"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "product_story"
        ]
      }
    },
    "/api/product_templates": {
      "get": {
        "operationId": "product_template-index",
        "parameters": [

        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/product_template"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "product_template"
        ]
      },
      "post": {
        "operationId": "product_template-create",
        "parameters": [

        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/product_template"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "product_template"
        ]
      }
    },
    "/api/product_templates/:id": {
      "get": {
        "operationId": "product_template-show",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/product_template"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "product_template"
        ]
      },
      "patch": {
        "operationId": "product_template-update",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/product_template"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "product_template"
        ]
      },
      "put": {
        "operationId": "product_template-update",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/product_template"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "product_template"
        ]
      },
      "delete": {
        "operationId": "product_template-destroy",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/product_template"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "product_template"
        ]
      }
    },
    "/api/product_template_marketplaces": {
      "get": {
        "operationId": "product_template_marketplace-index",
        "parameters": [

        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/product_template_marketplace"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "product_template_marketplace"
        ]
      }
    },
    "/api/product_template_marketplaces/:id": {
      "get": {
        "operationId": "product_template_marketplace-show",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/product_template_marketplace"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "product_template_marketplace"
        ]
      }
    },
    "/api/questions": {
      "get": {
        "operationId": "question-index",
        "parameters": [

        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/question"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "question"
        ]
      },
      "post": {
        "operationId": "question-create",
        "parameters": [

        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/question"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "question"
        ]
      }
    },
    "/api/questions/:id": {
      "get": {
        "operationId": "question-show",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/question"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "question"
        ]
      },
      "patch": {
        "operationId": "question-update",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/question"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "question"
        ]
      },
      "put": {
        "operationId": "question-update",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/question"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "question"
        ]
      },
      "delete": {
        "operationId": "question-destroy",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/question"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "question"
        ]
      }
    },
    "/api/credit_transactions": {
      "get": {
        "operationId": "credit_transaction-index",
        "parameters": [

        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/credit_transaction"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "credit_transaction"
        ]
      },
      "post": {
        "operationId": "credit_transaction-create",
        "parameters": [

        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/credit_transaction"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "credit_transaction"
        ]
      }
    },
    "/api/credit_transactions/:id": {
      "get": {
        "operationId": "credit_transaction-show",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/credit_transaction"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "credit_transaction"
        ]
      },
      "patch": {
        "operationId": "credit_transaction-update",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/credit_transaction"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "credit_transaction"
        ]
      },
      "put": {
        "operationId": "credit_transaction-update",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/credit_transaction"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "credit_transaction"
        ]
      },
      "delete": {
        "operationId": "credit_transaction-destroy",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/credit_transaction"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "credit_transaction"
        ]
      }
    },
    "/api/pipeline_runs": {
      "get": {
        "operationId": "pipeline_run-index",
        "parameters": [

        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/pipeline_run"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "pipeline_run"
        ]
      },
      "post": {
        "operationId": "pipeline_run-create",
        "parameters": [

        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/pipeline_run"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "pipeline_run"
        ]
      }
    },
    "/api/pipeline_runs/:id": {
      "get": {
        "operationId": "pipeline_run-show",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/pipeline_run"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "pipeline_run"
        ]
      },
      "patch": {
        "operationId": "pipeline_run-update",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/pipeline_run"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "pipeline_run"
        ]
      },
      "put": {
        "operationId": "pipeline_run-update",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/pipeline_run"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "pipeline_run"
        ]
      },
      "delete": {
        "operationId": "pipeline_run-destroy",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/pipeline_run"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "pipeline_run"
        ]
      }
    },
    "/api/llm_usage_records": {
      "get": {
        "operationId": "llm_usage_record-index",
        "parameters": [

        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/llm_usage_record"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "llm_usage_record"
        ]
      },
      "post": {
        "operationId": "llm_usage_record-create",
        "parameters": [

        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/llm_usage_record"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "llm_usage_record"
        ]
      }
    },
    "/api/llm_usage_records/:id": {
      "get": {
        "operationId": "llm_usage_record-show",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/llm_usage_record"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "llm_usage_record"
        ]
      },
      "patch": {
        "operationId": "llm_usage_record-update",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/llm_usage_record"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "llm_usage_record"
        ]
      },
      "put": {
        "operationId": "llm_usage_record-update",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/llm_usage_record"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "llm_usage_record"
        ]
      },
      "delete": {
        "operationId": "llm_usage_record-destroy",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/llm_usage_record"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "llm_usage_record"
        ]
      }
    },
    "/api/llm_usage_summary": {
      "get": {
        "operationId": "llm_usage_summary-index",
        "parameters": [

        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/llm_usage_summary"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "llm_usage_summary"
        ]
      }
    },
    "/api/queued_chat_messages": {
      "get": {
        "operationId": "queued_chat_message-index",
        "parameters": [

        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/queued_chat_message"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "queued_chat_message"
        ]
      },
      "post": {
        "operationId": "queued_chat_message-create",
        "parameters": [

        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/queued_chat_message"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "queued_chat_message"
        ]
      }
    },
    "/api/queued_chat_messages/:id": {
      "get": {
        "operationId": "queued_chat_message-show",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/queued_chat_message"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "queued_chat_message"
        ]
      },
      "patch": {
        "operationId": "queued_chat_message-update",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/queued_chat_message"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "queued_chat_message"
        ]
      },
      "put": {
        "operationId": "queued_chat_message-update",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/queued_chat_message"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "queued_chat_message"
        ]
      },
      "delete": {
        "operationId": "queued_chat_message-destroy",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/queued_chat_message"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "queued_chat_message"
        ]
      }
    },
    "/api/llm_models": {
      "get": {
        "operationId": "llm_model-index",
        "parameters": [

        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/llm_model"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "llm_model"
        ]
      }
    },
    "/api/llm_models/:id": {
      "get": {
        "operationId": "llm_model-show",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/llm_model"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "llm_model"
        ]
      }
    },
    "/api/code_gen_run_summary": {
      "get": {
        "operationId": "code_gen_run_summary-index",
        "parameters": [

        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/code_gen_run_summary"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "application/json": {
              }
            }
          },
          "403": {
            "description": "Forbidden",
            "content": {
              "application/json": {
              }
            }
          },
          "422": {
            "description": "Unprocessable Content",
            "content": {
              "application/json": {
              }
            }
          }
        },
        "tags": [
          "code_gen_run_summary"
        ]
      }
    }
  },
  "info": {
    "title": "Codalio API",
    "version": "0.0.0",
    "x-rhino": {
      "modules": {
        "rhino": {
          "version": "0.25.0.beta.11",
          "authOwner": "user",
          "baseOwner": "organization",
          "oauth": [
            {
              "name": "google_oauth2",
              "path": "/api/auth/omniauth/google_oauth2"
            },
            {
              "name": "azure_oauth2",
              "path": "/api/auth/omniauth/azure_oauth2"
            }
          ],
          "allow_signup": true
        },
        "rhino_organizations": {
          "version": "0.25.0.beta.11"
        },
        "rhino_subscriptions": {
          "version": "0.25.0.beta.11"
        }
      }
    }
  }
};

export default api;
